// Config init...
var _cfg = _config || {};
var dataLayer = dataLayer || [];
window._jts = window._jts || [];

var cls = {
    log : function( _output ){
        if( app.debug ){
            console.log.apply(this, arguments);
        }
    },
    warn : function(  ){
        if( app.debug ){
            console.warn.apply(this, arguments);
        }
    }
};

window.app || (window.app = {
    debug: false,
    debugTracking: true
});
app.modules || (app.modules = {});
app.tracker || (app.tracker = {});
app.tracking || (app.tracking = {});

app.tracker.jts = {
    _setup: function() {
        //window._jts = window._jts || [];
    },

    _permitted: function() {
        // note: mostly ignored previously
        return true || app.cookiePermissions.getServicePermission('gtm');
    },

    _track: function( data ) {
        if( typeof data !== 'object' ) {
            return;
        }

        if( typeof window._jts === 'undefined' ) {
            this._setup()
        }

        if( this._permitted() ) {
            if( app.debugTracking ) {
                console.log('JTS Tracking - push:', data);
            }
            _jts.push(data);
        }
    },

    trackTriggerEvent : function( category, action, label ) {
        var data = {
            'track': 'submit',
            'event': 'gaTriggerEvent',
        };
        if( typeof category !== 'undefined' && category !== null ) {
            data['category'] = category;
        }
        if( typeof action !== 'undefined' && action !== null ) {
            data['action'] = action;
        }
        if( typeof label !== 'undefined' && label !== null ) {
            data['label'] = label;
        }
        this._track( data );
    },
    trackVirtualPageView : function( url, additionalData ) {
        if( typeof url === 'undefined' || url === null || url === '' ) {
            return;
        }
        var data = {
            'track': 'submit',
            'event': 'VirtualPageView',
            'virtualPageURL': url
        };
        if( typeof additionalData === 'object') {
            $.extend( data, additionalData );
        }
        this._track( data );
    },
};

app.tracker.gtm = {
    _setup: function() {
        //window.dataLayer = window.dataLayer || [];
    },
    _permitted: function() {
        return true || app.cookiePermissions.getServicePermission('gtm');
    },
    _track: function( data ) {
        if( typeof data !== 'object' ) {
            return;
        }
        if( typeof window.dataLayer === 'undefined' ) {
            this._setup()
        }
        if( this._permitted() ) {
            if( app.debugTracking ) {
                console.log('GTM Tracking - push:', data);
            }
            dataLayer.push(data);
        }
    },

    trackTriggerEvent : function( category, action, label ) {
        var data = {
            'event': 'gaTriggerEvent',
        };
        if( typeof category !== 'undefined' && category !== null ) {
            data['gaEventCategory'] = category;
        }
        if( typeof action !== 'undefined' && action !== null ) {
            data['gaEventAction'] = action;
        }
        if( typeof label !== 'undefined' && label !== null ) {
            data['gaEventLabel'] = label;
        }
        this._track( data );
    },
    trackVirtualPageView : function( url, additionalData ) {
        if( typeof url === 'undefined' || url === null || url === '' ) {
            return;
        }
        var data = {
            'event': 'VirtualPageView',
            'virtualPageURL': url
        };
        if( typeof additionalData === 'object') {
            $.extend( data, additionalData );
        }
        this._track( data );
    }
};

app.tracker.multiplexer = {
    trackers : [
        app.tracker.jts, app.tracker.gtm
    ],
    trackTriggerEvent : function( category, action, label ) {
        this.trackers.forEach( function(tracker) {
            tracker.trackTriggerEvent(category, action, label);
        });
    },
    trackVirtualPageView : function( url, additionalData ) {
        this.trackers.forEach( function(tracker) {
            tracker.trackVirtualPageView( url, additionalData );
        });
    }
};

// "setup" active tracker
// legacy - jts
//app.tracking = app.tracker.jts;
// replacement - gtm
//app.tracking = app.tracker.gtm;
// both (gtm + jts)
app.tracking = app.tracker.multiplexer;


app.cookiePermissions = (function () {
    _config.cookieServices || (_config.cookieServices = {});

    var permissionsFormStorage = {};
    try {
        permissionsFormStorage = JSON.parse(localStorage.getItem('cookie-permissions'));
    } catch (e) {}

    var servicePermissions = Object.keys(_config.cookieServices).reduce(function (servicesObject, serviceName) {
        servicesObject[serviceName] = $.extend(
            {}, {
                isAllowed: !!_config.cookieServiceDefault,
                callbacks: []
            },
            _config.cookieServices[serviceName]
        );

        if (permissionsFormStorage && typeof permissionsFormStorage[serviceName] !== 'undefined') {
            servicesObject[serviceName].isAllowed = permissionsFormStorage[serviceName];
        }

        return servicesObject;
    }, {});

    var PIMCORE_TARGETING = 'pimcoreTargeting';
    var PIMCORE_TARGETING_COOKIE_NAME = 'pimcore_targeting_disabled';
    var COOKIE_DELETE_VALUE = '; expires=Thu, 01 Jan 1970 00:00:01 GMT;';

    if (servicePermissions[PIMCORE_TARGETING]) {
        if (hasCookie(PIMCORE_TARGETING_COOKIE_NAME)) {
            var cookieValue = getCookie(PIMCORE_TARGETING_COOKIE_NAME);
            servicePermissions[PIMCORE_TARGETING].isAllowed = !cookieValue;
        } else {
            document.cookie = PIMCORE_TARGETING_COOKIE_NAME + '=' + (servicePermissions[PIMCORE_TARGETING].isAllowed ? COOKIE_DELETE_VALUE : '1');
        }
    }

    if (_config.registerPermissionGrantedCallback) {
        _config.registerPermissionGrantedCallback.forEach(function (obj) {
            registerPermissionGrantedCallback(obj.service, obj.callback);
        });
    }

    function getServicePermission(serviceName) {
        if (typeof servicePermissions[serviceName] === 'undefined') {
            console.warn('getServicePermission of undefined service "' + serviceName + '". ' +
                'Add the service to _config.cookieServices or use one of the existing ones: ',
                Object.keys(servicePermissions)
            );
        }

        return !!servicePermissions[serviceName] && !!servicePermissions[serviceName].isAllowed;
    }

    /* callback: passed callback is only called once */
    function registerPermissionGrantedCallback(serviceName, callback) {
        if (!serviceName || !callback) {
            console.error('registerPermissionGrantedCallback: wrong arguments serviceName:String, callback:Function');
            return;
        }

        if (getServicePermission(serviceName)) {
            try {
                callback();
            } catch(error) {
                console.error(error);
            }
        } else {
            if (servicePermissions[serviceName] && servicePermissions[serviceName].callbacks) {
                servicePermissions[serviceName].callbacks.push(callback);
            } else {
                console.warn('registerPermissionGrantedCallback of undefined service "' + serviceName + '". ' +
                    'Add the service to _config.cookieServices or use one of the existing ones: ',
                    Object.keys(servicePermissions)
                );
            }
        }
    }

    function setServicePermission(serviceName, isAllowed) {
        servicePermissions[serviceName].isAllowed = isAllowed;
        if (isAllowed) {
            notifyCallbacks(serviceName);
        }

        try {
            var permissionsFormStorage = JSON.parse(localStorage.getItem('cookie-permissions')) || {};

            permissionsFormStorage[serviceName] = isAllowed;

            localStorage.setItem('cookie-permissions', JSON.stringify(permissionsFormStorage));
        } catch (e) {
            console.error(e);
        }

        if (serviceName === PIMCORE_TARGETING) {
            document.cookie = PIMCORE_TARGETING_COOKIE_NAME + '=' + (isAllowed ? COOKIE_DELETE_VALUE : '1');
        }

        if (window['dataLayer'] && typeof window.dataLayer.push === 'function') {
            window.dataLayer.push({
                event: 'cookie-permission-change'
            })
        }

    }

    function notifyCallbacks(serviceName) {
        if (servicePermissions[serviceName].callbacks) {
            var currentCallback;
            while (currentCallback = servicePermissions[serviceName].callbacks.shift()) {
                currentCallback();
            }
        }
    }

    function acceptAll() {
        Object.keys(servicePermissions).forEach(function (serviceName) {
            setServicePermission(serviceName, true);
        });
    }

    function declineAll() {
        Object.keys(servicePermissions).forEach(function (serviceName) {
            setServicePermission(serviceName, false);
        });
    }


    /* modal */
    var permissionModal;
    function showModal() {
        if (permissionModal) {
            permissionModal.remove();
        }

        permissionModal = createPermissionModal();
        notifyModalShowCallbacks();
        permissionModal.modal('show');
    }

    function hideModal() {
        if (permissionModal) {
            permissionModal.modal('hide');
        }
    }

    function createPermissionModal() {
        var $modal = $('<div class="cookie-modal modal fade" tabindex="-1" role="dialog" aria-labelledby="permissionModal" aria-hidden="true">' +
            '  <div class="modal-dialog" role="document">' +
            '    <div class="modal-content">' +
            '      <div class="modal-header">' +
            '        <h3 class="modal-title cookie-modal__title" id="permissionModal">' + _config.cookieModal.title + '</h3>' +
            '        <button type="button" class="close" data-dismiss="modal" aria-label="Close">' +
            '          <span aria-hidden="true">&times;</span>' +
            '        </button>' +
            '      </div>' +
            '      <div class="modal-body">' +
            '        ' + createServiceOptions(servicePermissions) +
            '      </div>' +
            '      <div class="modal-footer">' +
            '        <button type="button" class="btn btn-primary js-cookie-modal__save">' + _config.cookieModal.save + '</button>' +
            '      </div>' +
            '    </div>' +
            '  </div>' +
            '</div>');


        var $globalToggle = $modal.find('input[name="all"]');
        var $serviceToggles = $modal.find('input').not($globalToggle);
        $globalToggle.on('change', function () {
            if ($(this).is(':checked')) {
                $serviceToggles.prop('checked', 'checked');
            } else {
                $serviceToggles.prop('checked', null);
            }
        });

        $serviceToggles.on('change', function () {
            $globalToggle.prop('checked', $serviceToggles.not(':checked').length ? null: 'checked');
        });

        $modal.on('click', '.js-cookie-modal__save', function () {
            hideModal();
            $serviceToggles.toArray().forEach(function (input) {
                var serviceName = input.name;
                var isAllowed = $(input).is(':checked');

                setServicePermission(serviceName, isAllowed);
                hideCookieBar();
            });
        });

        $('body').append($modal);
        return $modal;
    }

    function createServiceOptions(services) {
        var options = [];

        if (Object.keys(services).length > 1) {
            options.push('<div class="cookie-modal__item cookie-modal__item--all">' +
                createServiceOption(_config.cookieModal.toggleAll, 'all', areAllServicesAllowed(services)) +
                '</div>');
        }

        options = options.concat(Object.keys(services).map(function (serviceName) {
            return ('<div class="cookie-modal__item">' +
                createServiceOption(services[serviceName].text, serviceName, services[serviceName].isAllowed) +
                createDetailLink(services[serviceName]) +
                '</div>'
            );
        }));

        return options.join('');
    }

    function createServiceOption(label, name, isChecked) {
        return (
            '<label class="cookie-modal__label">' +
            '  <span class="cookie-modal__switch">' +
            '    <input class="sr-only" name="' + name + '" type="checkbox" ' + (isChecked ? 'checked': '') + '>' +
            '    <span class="cookie-modal__switch-toggle"></span>' +
            '  </span>' +
            '  ' + label +
            '</label>'
        );
    }

    function areAllServicesAllowed(services) {
        return Object.keys(services).reduce(function (allAllowed, currentServiceName) {
            return !services[currentServiceName].isAllowed ? false: allAllowed;
        }, true);
    }

    function createDetailLink(service) {
        return (_config.cookieModal.detail && service.url)
            ? '<a class="cookie-modal__link" target="_blank" href="' + service.url + '">' + _config.cookieModal.detail + '</a>'
            : '';
    }


    /* cookie bar */
    var $cookieBar;
    function createCookieBar() {
        $cookieBar = $('<div class="cookie-bar js-cookie-bar">' +
            '    <div class="cookie-bar__text">' +
            '        ' + _config.cookieBar.text +
            '    </div>' +
            '    <div class="cookie-bar__detail">' +
            '     ' + createCookieBarDetailLink() +
            '     ' + createCookieBarSettingsLink() +
            '    </div>' +
            '    <div class="cookie-bar__buttons">' +
            '        ' + createDeclineButton() +
            '        ' + createAcceptButton() +
            '    </div>' +
            '</div>');

        $('body').append($cookieBar).addClass('has-cookie-bar');

        $cookieBar.on('click', '.js-cookie-bar__accept', function () {
            acceptAll();
            hideCookieBar();
        });

        $cookieBar.on('click', '.js-cookie-bar__decline', function () {
            declineAll();
            hideCookieBar();
        });

        $cookieBar.on('click', '.js-cookie-bar__detail', function () {
            showModal();
        });

        return $cookieBar;
    }

    function createDeclineButton() {
        return _config.cookieBar.decline
            ? '<button type="button" class="cookie-bar__decline btn btn-no-styling js-cookie-bar__decline">' +
            '    ' + _config.cookieBar.decline +
            '</button>'
            : '';
    }
    function createAcceptButton() {
        return _config.cookieBar.accept
            ? '<button type="button" class="cookie-bar__accept btn btn-primary js-cookie-bar__accept">' +
            '    ' + _config.cookieBar.accept +
            '</button>'
            : '';
    }

    function createCookieBarDetailLink() {
        return _config.cookieBar.detail
            ?   '<a target="_blank" href="' + _config.cookieBar.detailUrl +  '" class="cookie-bar__detail-btn btn btn-no-styling js-cookie-bar__detail-link">' +
            _config.cookieBar.detail +
            '</a>'
            : '';
    }

    function createCookieBarSettingsLink() {
        return _config.cookieBar.settings && _config.cookieServices && Object.keys(_config.cookieServices).length
            ?   '<button type="button" class="cookie-bar__detail-btn btn btn-no-styling js-cookie-bar__detail">' +
            _config.cookieBar.settings +
            '</button>'
            : '';
    }

    /* options.force: if set, force the cookie bar to be shown even if it was already dismissed */
    function showCookieBar(options) {
        options = options || [];

        if (options.force) {
            return createCookieBar();
        }

        var showCookieBar = true;
        try {
            showCookieBar = !localStorage.getItem('cookie-bar-dismissed');
        } catch (e) {}

        if (!showCookieBar && localStorage.getItem('cookie-permissions')) {
            var existingServices = Object.keys(JSON.parse(localStorage.getItem('cookie-permissions')));
            showCookieBar = !!(Object.keys(servicePermissions).filter(function (currentService) {
                return existingServices.indexOf(currentService) < 0
            }).length);
        }

        if (showCookieBar) {
            return createCookieBar();
        }
    }

    function hideCookieBar() {
        $('body').removeClass('has-cookie-bar');

        if ($cookieBar && $cookieBar.length) {
            $cookieBar.attr('hidden', 'hidden');
        }

        try {
            localStorage.setItem('cookie-bar-dismissed', true);
        } catch (e) {}
    }

    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    function hasCookie(cname) {
        return document.cookie.indexOf(cname) >= 0;
    }

    var openCallbacks = [];
    function onModalShow(cb) {
        openCallbacks.push(cb);
    }

    function notifyModalShowCallbacks () {
        openCallbacks.forEach(function (cb) {
            cb(permissionModal);
        });
    }

    $('.js-show-cookie-modal').on('click', function (evt) {
        evt.preventDefault();

        showModal();
    });


    return {
        getServicePermission: getServicePermission,
        registerPermissionGrantedCallback: registerPermissionGrantedCallback,
        setServicePermission: setServicePermission,
        showModal: showModal,
        hideModal: hideModal,
        showCookieBar: showCookieBar,
        hideCookieBar: hideCookieBar,
        onModalShow: onModalShow
    };
}());
if(!_config.disableCookieBar) {
    app.cookiePermissions.showCookieBar();
}

app.modules.ajaxInclude = (function () {
    function ajaxIncludeCallback() {
        var includedContainer = $(this).next();

        if ($(this).is('[data-target]')) {
            var targetContainer = $($(this).data('target'));
            if (targetContainer.length > 0) {
                includedContainer = targetContainer;
            }
        }
        app.initModules(includedContainer);
        $(this).off('ajaxInclude', ajaxIncludeCallback);

        if (_config && _config['debug']) {
            console.warn('ajax included: ', includedContainer);
        }
    }

    return function ($scope) {
        var ajaxIncludeElements = $scope.find('.js-ajaxInclude');
        var ajaxIncludeOptions = {
            device: matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop'
        };

        ajaxIncludeElements.on('ajaxInclude', ajaxIncludeCallback).extendAjaxInclude(ajaxIncludeOptions);

        ajaxIncludeElements.filter('[data-interaction=click]').on('click', function(){
            $(this).children('.loading').attr('hidden', false);

            $(this).removeAttr('data-interaction');
            $(this).on('ajaxInclude', ajaxIncludeCallback).extendAjaxInclude({
                device: matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop'
            });
        });

    };

}());

app.modules.isClickable = (function () {
    function isClickable( obj, newTab ){
        var $this = obj,
            link = $this.find('a:first'),
            href = link.attr('href'),
            target = link.attr('target');
        if( target == '_blank' || newTab ){
            window.open( href );
        }else{
            window.location.href = href;
        }
    }

    function initScope($scope) {
        $scope.find('.isClickable').on('click', function(evt){
            if (!$(evt.target).is('a')) {
                isClickable( $(this));
            }
        });
    }

    return initScope;
}());

app.modules.addFormFields = function($scope) {
    var countInput = $('.js-add-fields-count');

    String.prototype.insertAt=function(index, string) {
        return this.substr(0, index) + string + this.substr(index);
    };

    function createInput(template, count) {
        var formBlock = $(template);

        formBlock.find('.control-label').each(function(){
            var labelFor = $(this).attr('for');
            $(this).attr('for', labelFor.insertAt(labelFor.indexOf('['), '[' + count + ']'));
        });
        formBlock.find('.form-control').each(function(){
            var id = $(this).attr('id');
            $(this).attr('id', id.insertAt(id.indexOf('['), '[' + count + ']'));
            var name = $(this).attr('name');
            $(this).attr('name', name.insertAt(name.indexOf('['), '[' + count + ']'));
        });

        //add count
        countInput.val(parseInt(countInput.val()) + 1);
        return formBlock;
    }

    $scope.find('.js-add-fields').on('click', function (evt) {
        evt.preventDefault();
        var container = $('.js-add-fields-container');

        var template = $($(this).data('form-template')).html();

        var count = $('.js-add-fields-form').length,
            $newInputs = createInput(template, count);

        container.append($newInputs);
        app.initModules($newInputs);
    });

    $scope.find('.js-add-fields-form__remove').on('click', function (evt) {
        evt.preventDefault();

        $(this).closest('.js-add-fields-form').remove();
        countInput.val(parseInt(countInput.val()) - 1);
    })
};

app.modules.slider = function ($scope) {
    $.loadScript('/static/build/js/libs/slick.min.js').done(function(){
        var slickOptions = {
            slidesToShow: 1,
            nextArrow: '<button type="button" class="slick-next btn slider__arrow" aria-label="Next"><span class="icon-btn__icon icon icon-arrow-right"></span></button>',
            prevArrow: '<button type="button" class="slick-prev btn slider__arrow" aria-label="Previous"><span class="icon-btn__icon icon icon-arrow-left"></span></button>',
            dots: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        arrows: false
                    }
                }
            ]
        };

        $scope.find('.js-slider').each(function () {
            var $this = $(this),
                options = $.extend({}, slickOptions);

            $this.slick(options);
        });
    });
};

app.modules.imgSlider = function ($scope) {
    $.loadScript('/static/build/js/libs/slick.min.js').done(function(){
        var slickOptions = {
            slidesToShow: 1,
            nextArrow: '<button type="button" class="slick-next icon-btn btn btn-dark slider__arrow" aria-label="Next"><span class="icon-btn__icon icon icon-arrow-right"></span></button>',
            prevArrow: '<button type="button" class="slick-prev icon-btn btn btn-dark slider__arrow" aria-label="Previous"><span class="icon-btn__icon icon icon-arrow-left"></span></button>',
            dots: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        arrows: false
                    }
                }
            ]
        };

        $scope.find('.js-img-slider').each(function () {
            var $this = $(this),
                options = $.extend({}, slickOptions);

            $this.slick(options);

            var $tabPaneParent = $this.closest('.tab-pane');
            if ($tabPaneParent && $tabPaneParent.length) {
                /*refresh the slider when it was hidden in a tab*/
                var $tabTrigger = $('[href="#' + $tabPaneParent.attr('id') + '"],[data-toggle=tab][data-target="#' + $tabPaneParent.attr('id') + '"]');
                $tabTrigger.one('shown.bs.tab', function () {
                    $this.slick('setPosition');
                });
            }
        });
    });
};

app.modules.sliderWithThumbs = function ($scope) {
    $.loadScript('/static/build/js/libs/slick.min.js').done(function(){
        /*todo translations*/
        var defaultMainSlickOptions = {
            speed: 300,
            nextArrow: '<button type="button" class="slick-next icon-btn btn btn-primary slider__arrow" aria-label="Next"><span class="icon-btn__icon icon icon-arrow-right"></span></button>',
            prevArrow: '<button type="button" class="slick-prev icon-btn btn btn-primary slider__arrow" aria-label="Previous"><span class="icon-btn__icon icon icon-arrow-left"></span></button>',
            dots: true
        };
        var defaultThumbSlickOptions = {
            speed: 200,
            slides: 3,
            arrows: false,
            slidesToShow: 3,
            swipeToSlide: true,
            slidesToScroll: 3,
            centerMode: true,
            focusOnSelect: true,
            centerPadding: "0",
            dots: true
        };

        $scope.find('.js-slider-with-thumbs').each(function () {
            var mainSlickOptions = $.extend({}, defaultMainSlickOptions);
            var $mainSlider = $(this).find('.js-slider-with-thumbs__main');

            if (!matchMedia('(max-width: 767px)').matches) {
                var $thumbSlider = $(this).find('.js-slider-with-thumbs__thumbs');

                app.modules.sliderWithThumbs.elementId++;
                var mainId = 'slider-with-thumbs-main-' + app.modules.sliderWithThumbs.elementId;
                var thumbId = 'slider-with-thumbs-thumb-' + app.modules.sliderWithThumbs.elementId;

                $mainSlider.attr('id', mainId);
                $thumbSlider.attr('id', thumbId);

                mainSlickOptions.asNavFor =  '#' + thumbId;

                $thumbSlider.slick($.extend({}, defaultThumbSlickOptions, {
                    asNavFor: '#' + mainId
                }));
            }

            $mainSlider.slick(mainSlickOptions);

            var $tabPaneParent = $mainSlider.closest('.tab-pane');
            if ($tabPaneParent && $tabPaneParent.length) {
                /*refresh the slider when it was hidden in a tab*/
                var $tabTrigger = $('[href="#' + $tabPaneParent.attr('id') + '"],[data-toggle=tab][data-target="#' + $tabPaneParent.attr('id') + '"]');
                $tabTrigger.one('shown.bs.tab', function () {
                    $mainSlider.slick('setPosition');
                    $thumbSlider.slick('setPosition');
                });
            }
        });
    });
};

app.modules.sliderWithThumbs.elementId = 0;

app.modules.thumbSlider = function ($scope) {
    var $slider = $scope.find('.js-thumb-slider');

    $.loadScript('/static/build/js/libs/slick.min.js').done(function(){
        var slickOptions = {
            slidesToShow: 9,
            dots: false,
            swipeToSlide: true,
            speed: 180,
            infinite: true,
            nextArrow: '<button type="button" class="slick-next icon-btn btn btn-primary slider__arrow" aria-label="Next"><span class="icon-btn__icon icon icon-arrow-right"></span></button>',
            prevArrow: '<button type="button" class="slick-prev icon-btn btn btn-primary slider__arrow" aria-label="Previous"><span class="icon-btn__icon icon icon-arrow-left"></span></button>'
        };

        $slider.each(function () {
            var $this = $(this),
                options = $.extend({}, slickOptions);

            $this.slick(options);
        });
    });
};

app.modules.compareSlider = function ($scope) {
    var $slider = $scope.find('.js-compare-slider');
    $.loadScript('/static/build/js/libs/slick.min.js').done(function(){
        var slickOptions = {
            slidesToShow: 3,
            arrows: false,
            draggable: false,
            infinite: false
        };

        $slider.each(function () {
            var $this = $(this),
                options = $.extend({}, slickOptions);

            $this.slick(options);
        });
    });

    $('.js-compare-list').each(function () {
        var $this = $(this);

        if($this.closest('.tab-pane').hasClass('active')) {
            calcCellHeight($this);
        }
    });

    function calcCellHeight($this) {
        var $items = $this.find('.js-compare-list-item'),
            $compareLegend = $this.find('.compare-list__legend'),
            rowlength = $this.find('.compare-cell', $items.eq(0)).length;

        for ( var i = 0; i < rowlength; i++ ) {
            var colheight = 0;

            $items.each(function() {
                var currentcell = $(".compare-cell:eq("+i+")", $(this));
                if ( currentcell.height() > colheight ) {
                    colheight = currentcell.height();
                }
            });
            var currentlegendcell = $(".compare-cell:eq("+i+")", $compareLegend);
            currentlegendcell.height(colheight);
            $items.each(function() {
                var currentcell = $(".compare-cell:eq("+i+")", $(this));
                currentcell.height(colheight);
            });
        }

        // if ($slider.hasClass('slick-initialized')){
        // 	$this.css('padding-top', $this.find('.compare-list__top').height());
        // } else {
        // 	$slider.on('init', function(){
        // 		$this.css('padding-top', $this.find('.compare-list__top').height());
        // 	});
        // }

    };

    $('.js-compare-list-tabs').on('shown.bs.tab', function () {
        $slider.slick('setPosition');

        var $tab = $($(this).attr('href'));
        calcCellHeight($tab.find('.js-compare-list'));
    });

    // calcCellHeight($this);

    $('.js-compare-list-next').on('click', function () {
        $slider.slick('slickNext');
    });
    $('.js-compare-list-prev').on('click', function () {
        $slider.slick('slickPrev');
    });
};

app.modules.lightboxGroup = function ($scope) {
    $.loadScript('/static/build/js/libs/lightgallery.min.js').done(function () {
        console.log('loaded ')
        if($scope.find('.js-lightbox-group--video').length){
            $.loadScript('/static/build/js/libs/lg-video.min.js');
            $.loadScript('/static/build/js/libs/video.js');
        }

        $scope.find('.js-lightbox-group').each(function () {
            if ($(this).find('.slick-slide') && $(this).find('.slick-slide').length) {
                $(this).lightGallery({
                    selector: '.slick-slide:not(.slick-cloned) .js-lightbox-group__item',
                    animateThumb: false,
                    download: false,
                    videojs: $(this).hasClass('js-lightbox-group--video'),
                    prevHtml: "<span class='icon icon-arrow-left'></span>",
                    nextHtml: "<span class='icon icon-arrow-right'></span>"
                });
            } else {
                $(this).lightGallery({
                    selector: '.js-lightbox-group__item',
                    animateThumb: false,
                    download: false,
                    videojs: $(this).hasClass('js-lightbox-group--video'),
                    prevHtml: "<span class='icon icon-arrow-left'></span>",
                    nextHtml: "<span class='icon icon-arrow-right'></span>"
                });
            }
        });

        //prevent isClickable
        $scope.find('.js-lightbox-group__item').on('click', function (evt) {
            evt.stopImmediatePropagation();
        });
    });
};

app.lightboxGroup = function () {
    $('body').on('click', '.js-lightbox-group__switch', function () {
        var $groupsParent = $('.js-lightbox-groups');
        var index = $(this).data('index') ? $(this).data('index') : 0;
        var lightGalleryToOpen;
        console.log('click', $groupsParent);
        $groupsParent.find('.js-lightbox-group').each(function () {
            var lightGallery = $(this).data('lightGallery');
            // console.log('lightGallery', lightGallery);
            if (lightGallery.lGalleryOn) {
                lightGallery.$el.on('onCloseAfter.lg', function () {
                    if (lightGalleryToOpen) {
                        if (lightGalleryToOpen.$el.find('.slick-current .js-lightbox-group__item').length) {
                            lightGalleryToOpen.$el.find('.slick-current .js-lightbox-group__item').first().trigger('click');
                        } else  {
                            lightGalleryToOpen.$el.find('.js-lightbox-group__item:nth-child('+ index +')').trigger('click');
                        }

                        lightGalleryToOpen = null;
                    }
                });
                lightGallery.destroy();
            } else {
                lightGalleryToOpen = lightGallery;
            }
        });
    });
};

app.modules.scrollTo = (function () {
    function scrollTo ($target, callback) {
        if (!$target || !$target.length) {
            console.warn("Can't scroll to '" + target + "'. Target element not found");
            return;
        }

        if (app.affixNavBar) {
            app.affixNavBar.disable();
        }

        var duration = Math.abs($target.offset().top - window.scrollY) / 8 + 100;

        $('html, body').stop().animate({
                scrollTop: $target.offset().top - 30
            },
            duration,
            'swing', function () {
                if (app.affixNavBar) {
                    app.affixNavBar.enable();
                }

                if (callback) {
                    callback();
                }
            }
        );
    }

    function focus ($target) {
        if (typeof $target.attr('tabindex') == 'undefined') {
            $target.addClass('hide-focus');
            $target.attr('tabindex', '-1');
        }
        $target.focus();
    }

    return function ($scope) {
        $scope.find('.js-scroll-to').on('click', function (evt) {
            evt.preventDefault();
            var targetSelector = $(this).data('scroll-target') || $(this).attr('href');
            var $target = $(targetSelector);

            switch ($(this).data('toggle')) {
                case 'tab':
                    if ($target.hasClass('in')) {
                        scrollTo($target, function () {
                            focus($target);
                        });
                        evt.stopPropagation();
                        return;
                    }

                    /*scroll to parent because we can't know where the actual child is*/
                    scrollTo($target.parent(), function () {
                        focus($target);
                    });

                    /*update bootstrap nav classes because bootstrap doesn't handle them*/
                    var navTabTrigger = $('.nav [data-toggle="tab"]').filter('[href="' + targetSelector + '"], [data-target="' + targetSelector + '"]');
                    navTabTrigger.each(function () {
                        var $navItems = $(this).closest('.nav').find('li');

                        $navItems.removeClass('active')
                            .find('a').attr('aria-expanded', 'false');

                        $(this).attr('aria-expanded', 'true')
                            .parent().addClass('active');

                    });
                    break;
                case 'collapse':
                    if ($target.hasClass('in')) {
                        scrollTo($target, function () {
                            focus($target);
                        });
                        evt.stopImmediatePropagation();
                        return;
                    }

                    /*scroll to parent because we can't know where the actual child is*/
                    scrollTo($target.parent(), function () {
                        focus($target);
                    });

                    break;
                default:
                    scrollTo($target, function () {
                        focus($target);
                    });
            }
        });
    };
}());

// app.modules.copyUrlToClipboard = function ($scope) {
//     $scope.find('.js-copy-url-to-clipboard').on('click', function () {
//         var $temp = $("<input>");
//         $("body").append($temp);
//         $temp.val(location.href).select();
//         document.execCommand("copy");
//         $temp.remove();
// 		if ($(this).data('copy-success-msg')) {
// 			alert($(this).data('copy-success-msg'));
// 		}
//     });
// };

app.modules.offScreenFilter = function ($scope) {
    if (matchMedia('(min-width: 768px)').matches) {
        return;
    }
    $scope.find('.js-open-offscreen').on('click', function (evt) {
        evt.preventDefault();

        var $this = $(this);
        var $target = $($this.attr('href'));

        if(!$target.hasClass('is-open')) {
            $target.addClass('is-open');
        } else {
            $target.removeClass('is-open');
        }
    });
};

app.modules.centerActiveTab = function($scope) {
    var activeTab = $scope.find('.js-center-active').find('.active'),
        navTab = $scope.find('.js-center-active').find('li');

    calcCenter(activeTab);

    navTab.on('click', function () {
        calcCenter($(this))
    });

    function calcCenter(tab) {
        if(tab && tab.length) {
            var childPos = tab.offset().left,
                parentScroll = tab.parent().scrollLeft(),
                offset = childPos + parentScroll - window.outerWidth/2 + tab.width()/2;

            navTab.closest('ul').animate({ scrollLeft: offset }, 250);
        }
    }
};


app.modules.tabGroup = function ($scope) {
    $scope.find('.js-tab-group a[data-toggle="tab"]').on('show.bs.tab', function () {
        $(this).closest('.js-tab-group').find('li').removeClass('active');
    });
};


app.modules.fancyTabFunction = function ($scope) {
    if (window.location.href.indexOf("#test-drive-form") > -1) {
        $scope.find('.js-a-link-tab-drive').tab('show');
        $scope.find('.js-tab-form-drive').addClass('active in');
    }
    else {
        $scope.find('.js-a-link-tab-consultation').tab('show');
        $scope.find('.js-tab-form-consultation').addClass('active in');
    }
};

function isFocusable( $el ) {
    var tabIndex = +$el.attr( "tabindex" );
    tabIndex = isNaN( tabIndex ) ? -1 : tabIndex;
    return $el.is( ":input, a[href], button[data-href], area[href], iframe" ) || tabIndex > -1;
}
/*app.toc*/
(function () {
    var id = 0;
    function addTocEntry (text, anchorId) {
        $tocList.append('<li><button class="sr-only sr-only-focusable" data-href="#' + anchorId + '">' + text + '</button></li>');
    }

    var $tocList;
    app.toc = function () {
        $tocList = $('.js-toc__list');
        if (!$tocList || !$tocList.length) {
            console.warn('can\'t render Table of content. No js-toc__list found');
        }

        $tocList.on('click', 'button', function () {
            var $target = $($(this).attr('data-href'));

            if (!$target || !$target.length) {
                console.warn('Could not jump to "', $(this).attr('data-href'), '". Element was not found');
                return;
            }

            var $tabPaneParent = $target.closest('.tab-pane:not(.active)');
            var $collapseParent = $target.closest('.collapse:not(.in)');

            if ($tabPaneParent && $tabPaneParent.length) {
                var targetSelector = '#' + $tabPaneParent.attr('id');
                var $trigger = $('[data-toggle="tab"]').filter('[data-target="'+targetSelector+'"],[href="'+targetSelector+'"]');
                $trigger.tab('show');
                window.scrollTo(window.scrollX, $tabPaneParent.parent().offset().top);
            } else if ($collapseParent && $collapseParent.length) {
                $collapseParent.collapse('show');
                window.scrollTo(window.scrollX, $collapseParent.parent().offset().top);
            } else {
                window.scrollTo(window.scrollX, $target[0].offsetTop -100);
                $target.focus();
            }
        });
    };

    app.modules.toc = function($scope) {
        $scope.find('.js-toc__title').each(function () {
            var $title = $(this);
            var anchorId = 'toc-entry-target-' + id;
            $title.attr('id', 'toc-entry-target-' + id);
            if (!isFocusable($title)) {
                $title.attr('tabindex', '-1');
            }
            id++;
            addTocEntry($title.text(),anchorId);
        });
    }
}());

app.modules.skipLinks = function ($scope) {
    $scope.find('.js-skip-links').each(function () {
        // wpo skip link test (skip links are not allowed to be a-tag
        var $skiplinks = $(this);
        $skiplinks.on('click', function () {
            var $target = $($(this).attr('data-href'));
            window.scrollTo(window.scrollX, $target[0].offsetTop);
            $target.focus();
        });
    });
}

/*app.affixNavBar*/
if ((!matchMedia('(max-width: 767px)').matches) && !(_cfg.iframeIntegration || false) ) {
    (function () {
        // Hide Header on on scroll down
        var didScroll;
        var lastScrollTop = 0;
        var delta = 1;
        var navbarHeight;
        var defaultTopPosition;
        var $navbar;
        var $navbarContainer;
        var isTransitioning = false;
        var isFixed = false;
        var isDisabled = false;

        function scrollHandler() {
            var scrollTopPosition = $(this).scrollTop();
            if (Math.abs(lastScrollTop - scrollTopPosition) <= delta)
                return;

            if (isDisabled) {
                lastScrollTop = scrollTopPosition;
                return;
            }

            var navbarOffset = $navbar.offset().top;

            if (scrollTopPosition <= defaultTopPosition) {
                $navbar.removeClass('is-affix').css('top', 0).removeClass('is-transitioning');
                isFixed = false;
                isTransitioning = true;
                return;
            }

            if (lastScrollTop > scrollTopPosition) {
                /*scroll up*/

                if (!isFixed) {
                    if (isTransitioning) {
                        if (navbarOffset >= scrollTopPosition) {
                            /*end of transtion*/
                            isTransitioning = false;
                            isFixed = true;
                            $navbar.css('top', 0);
                            $navbar.addClass('is-affix');
                            $navbar.removeClass('is-transitioning');
                        }
                    } else {
                        $navbar.addClass('is-transitioning').css({
                            top: scrollTopPosition - navbarHeight
                        });
                        isTransitioning = true;
                    }
                }
            } else if (lastScrollTop < scrollTopPosition) {
                /*scroll down*/

                if (isFixed) {
                    $navbar.removeClass('is-affix');

                    $navbar.css({
                        top: lastScrollTop
                    }).addClass('is-transitioning');

                    isTransitioning = true;
                    isFixed = false;
                }

                if (isTransitioning) {
                    if (navbarOffset + navbarHeight <= scrollTopPosition) {
                        isTransitioning = false;
                    }
                }
            }

            lastScrollTop = scrollTopPosition;
        }

        app.affixNavBar = function () {
            $navbar = $('.js-affix-nav-bar');
            $navbarContainer = $('.js-affix-nav-bar-container');
            defaultTopPosition = $navbarContainer.offset().top;

            $(window).one('scroll', function () {
                navbarHeight = $navbar[0].getBoundingClientRect().height; /*get exact height (jquery returns rounded value)*/
                $navbarContainer.height(navbarHeight);
            });

            $(window).scroll(function (event) {
                didScroll = true;
            });

            requestAnimationFrame(function animationFrameHandler() {
                if (didScroll) {
                    scrollHandler();
                    didScroll = false;
                }
                requestAnimationFrame(animationFrameHandler);
            });
        };

        app.affixNavBar.disable = function (disableAtAffixState) {
            if (disableAtAffixState) {
                $navbar.addClass('is-affix').css('top', 0).removeClass('is-transitioning');
                isFixed = true;
                isTransitioning = false;
            } else {
                $navbar.removeClass('is-affix').css('top', 0).removeClass('is-transitioning');
                isFixed = false;
                isTransitioning = false;
            }

            isDisabled = true;
        };

        app.affixNavBar.enable = function () {
            isDisabled = false;
        };

        app.affixNavBar.getAffixNavBarHeight = function () {
            return $('.js-affix-nav-bar').height() || 0;
        };

        app.affixNavBar.isInDefaultState = function () {
            return !$navbar.hasClass('is-transitioning') && !$navbar.hasClass('is-affix');
        };


    }());
}

/*app.affixSidebar*/
if (!matchMedia('(max-width: 767px)').matches) {
    app.affixSidebar = function () {
        // function freezeSidebars() {
        // 	$sidebars.each(function () {
        // 		var $sidebar = $(this);
        // 		if ($sidebar.hasClass('affix')) {
        // 			var $container = $sidebar.closest('.js-affix-sidebar-container, .js-sidebar-container');
        // 			var offset = $sidebar.offset().top;
        // 			// if ($sidebar.hasClass('is-frozen')) {
        // 			//     console.log('inner if');
        // 			//     $sidebar.removeClass('is-frozen');
        // 			//     $sidebar.css({
        // 			//         top: offset - $container.offset().top
        // 			//     });
        // 			//
        // 			// }
        //
        //
        //
        // 			$sidebar.addClass('is-frozen');
        // 			$sidebar.removeClass('affix affix-top');
        // 			$sidebar.css({
        // 				top: offset - $container.offset().top
        // 			});
        // 		}
        // 	});
        // }

        var $sidebars = $('.js-affix-sidebar').each(function () {
            var $sidebar = $(this);
            var $placeholder = $sidebar.closest('.js-affix-sidebar-placeholder');
            var $container = $sidebar.closest('.js-affix-sidebar-container');
            var navHeight = app.affixNavBar.getAffixNavBarHeight();

            if (!$container || !$container.length) {
                console.warn('app.affixSidebar: Could not find ".js-affix-sidebar-container" for ', $sidebar, '.');
                return;
            }

            $sidebar.on('affix.bs.affix', function () {
                $placeholder.css('min-height', $placeholder.height());

                $sidebar.css({
                    top: navHeight,
                    left: $sidebar.offset().left + 'px',
                    width: $sidebar.outerWidth() + 'px'
                });
            }).on('affix-bottom.bs.affix affix-top.bs.affix', function () {
                $sidebar.css({
                    top: '',
                    left: ''
                });
            });

            if (!$sidebar.height() + navHeight < window.innerHeight) {
                $sidebar.affix({
                    offset: {
                        top: function() {
                            return $placeholder.offset().top - navHeight;

                        },
                        bottom: function () {
                            return window.document.body.scrollHeight - $container.offset().top - $container.height()
                                + ($sidebar.outerHeight() - $sidebar.height()); /*because bootstrap uses height instead of the correct outerHeight */
                        }
                    }
                });
            }
        });

        $('.js-affix-sidebar-bottom').each(function () {
            var $sidebar = $(this);
            var $placeholder = $('.js-affix-sidebar-bottom-placeholder');
            var $container = $sidebar.closest('.js-affix-sidebar-bottom-container');
            var navHeight = app.affixNavBar.getAffixNavBarHeight();
            var bottomOffset = 80;

            if (!$container || !$container.length) {
                console.warn('app.affixSidebar: Could not find ".js-affix-sidebar-bottom" for ', $sidebar, '.');
                return;
            }

            $sidebar.on('affix.bs.affix', function () {
                $placeholder.css('min-height', $placeholder.height());
                $sidebar[0].style.position = '';

                $sidebar.css({
                    bottom: bottomOffset + 'px',
                    width: $placeholder.width(),
                    left: $placeholder.offset().left
                });
            }).on('affix-bottom.bs.affix affix-top.bs.affix', function () {
                $sidebar.css({
                    bottom: 0,
                    left: ''
                });
            });

            if (!$sidebar.height() + navHeight < window.innerHeight) {

                $sidebar.affix({
                    offset: {
                        // top value is not used because it causes problems on scrolling up
                        /*top: function() {
                            return $container.offset().top - window.innerHeight - $placeholder.height() ;
                        },*/
                        bottom: function () {
                            return window.document.body.scrollHeight - ($placeholder.offset().top + $placeholder.height());
                        }
                    }
                })
            }
        });

        // $('body').on('show.bs.collapse hide.bs.collapse', function (evt) {
        // 	freezeSidebars();
        // }).on('shown.bs.collapse hidden.bs.collapse', function (evt) {
        // 	$sidebars.each(function () {
        // 		var $sidebar = $(this);
        // 		if ($sidebar.hasClass('is-frozen')) {
        // 			$sidebar.removeClass('affix affix-top');
        // 		}
        // 	});
        // });
    }
}

/*app.bottomBar*/
if (!matchMedia('(max-width: 767px)').matches) {
    app.affixBottomBar = function () {
        $('.js-affix-bottom-bar').each(function () {
            var $bottomBar = $(this),
                $placeholder = $('.js-affix-bottom-bar-placeholder'),
                $container = $bottomBar.closest('.js-affix-bottom-bar-container'),
                navHeight = app.affixNavBar.getAffixNavBarHeight();

            var $offsetItem = $($bottomBar.data('offset-target'));

            if (!$container || !$container.length) {
                console.warn('app.affixBottomBar: Could not find ".js-affix-bottom-bar" for ', $bottomBar, '.');
                return;
            }

            $bottomBar.on('affix.bs.affix', function () {
                $placeholder.css('min-height', $placeholder.height());
                $bottomBar[0].style.position = '';

                $bottomBar.css({
                    bottom: '0px',
                    left: 0,
                    right: 0
                });
            }).on('affix-bottom.bs.affix affix-top.bs.affix', function () {
                $bottomBar.css({
                    bottom: 0,
                    left: ''
                });
            });

            if (!$bottomBar.height() + navHeight < window.innerHeight) {
                $bottomBar.affix({
                    offset: {
                        top: function () {
                            return $offsetItem.offset().top + $offsetItem.outerHeight();
                        },
                        bottom: function () {
                            return window.document.body.scrollHeight - ($placeholder.offset().top + $placeholder.height());
                        }
                    }
                })
            }
        });
    }
}

if (!matchMedia('(max-width: 767px)').matches) {
    app.affixFilterButton = function () {
        var $button = $('.js-affix-filter-btn');

        $button.on('affix.bs.affix', function () {
            $button.css({
                left: $button.offset().left + 'px',
                width: $button.outerWidth() + 'px'
            });
        }).on('affix-bottom.bs.affix affix-top.bs.affix', function () {
            $button.css({
                left: ''
            });
        });

        $button.affix({
            offset: {
                top: -1, /*because 0 would cause strange effects on click*/
                bottom: function () {
                    return window.document.body.scrollHeight - $button.closest('form').offset().top - $button.closest('form').outerHeight() - 35;
                }
            }
        });
    };
}

app.affixScrollTopButton = function () {
    if (_cfg.affixScrollTopButton == false) {
        return;
    }

    var $button = $('.js-affix-scroll-top-btn');

    $button.on('affix.bs.affix', function () {
        $button.css({
            left: $button.offset().left + 'px',
            width: $button.outerWidth() + 'px'
        });
    }).on('affix-bottom.bs.affix affix-top.bs.affix', function () {
        $button.css({
            left: ''
        });
    });

    $button.affix({
        offset: {
            top: 500
        }
    });
};

app.modules.compareAffix = function ($scope) {
    $scope.find('.js-affix-compare').each(function () {
        var $this = $(this),
            $wrapper = $this.closest('.js-affix-compare-wrapper'),
            $container = $this.closest('.compare-list');
        // viewportHeight = window.innerHeight / 2;

        $this.on('affix.bs.affix', function () {
            $wrapper.css('min-height', $wrapper.height() + 'px');
        });

        $this.affix({
            offset: {
                top: function () {
                    return $wrapper.offset().top;
                },
                bottom: function () {
                    return window.document.body.scrollHeight - $container.offset().top - $container.height() + window.innerHeight / 2;
                }
            }
        });
    });
};

app.modules.affix = function ($scope) {
    $scope.find('.js-affix').each(function () {
        var $this = $(this);
        var $placeholder = $(this).closest('.js-affix-placeholder');

        if (!$placeholder || !$placeholder.length) {
            console.error('Affix element', $this, 'is missing a placeholder wrapper(".js-affix-placeholder")')
            return;
        }

        $placeholder.css({
            'min-height': $placeholder.height()
        });

        $this.affix({
            offset: {
                top: function () {
                    return $placeholder.offset().top - $this.data('affix-offset');
                }
            }
        });
    });
};

app.modules.datepicker = (function () {
    function init($scope) {
        var defaultOptions = {
            minDate: 0,
            altFormat: "@",
            firstDay: 1,
            changeYear: true,
            yearRange: "-100:+100"
        };

        var datePicker = $scope.find('.js-datepicker');

        datePicker.each(function () {
            var $datePickerInput = $(this);
            var $altField = $datePickerInput.closest('.form-group').find('.js-datepicker__timestamp');
            var weekdayOnly = $datePickerInput.hasClass('js-datepicker--weekday-only');
            var datePickerOptions = $.extend({}, defaultOptions, {
                altField: $altField,
                minDate: $datePickerInput.data('min-date') != undefined ? $datePickerInput.data('min-date') : new Date(new Date().toDateString()), /*current date; new Date() returns current time*/
                maxDate: $datePickerInput.data('max-date') != undefined ? $datePickerInput.data('max-date') : null
            });

            datePickerOptions.beforeShowDay = function (date) {
                if (weekdayOnly){
                    if(date.getDay() == 0 || date.getDay() == 6) {
                        return [false, ''];
                    }
                    // Exclude public holidays
                    if (_cfg.publicHolidays) {
                        var dateString = jQuery.datepicker.formatDate('yy-mm-dd', date);
                        return [ _cfg.publicHolidays.indexOf(dateString) === -1 ]
                    }
                }

                return [true, ''];
            };

            $datePickerInput.datepicker(datePickerOptions);

            if ($datePickerInput.hasClass('js-datepicker--min-date')) {
                $datePickerInput.datepicker('option', 'minDate', new Date($datePickerInput.data('min-date')));
                $datePickerInput.datepicker('setDate', new Date($datePickerInput.data('min-date')));
            }

            if ($altField.val()) {
                $datePickerInput.datepicker('setDate', new Date(parseInt($altField.val())));
            }
        });

        $scope.find('.js-trigger-datepicker').on('click', function () {
            var $datepicker = $($(this).data('target'));

            $(this).closest('.form-group').find($datepicker).datepicker("show");
        });
    }

    return function($scope) {
        $.loadScript("/static/js/libs/jquery-ui.min.js").done(function () {
            if (!_cfg.lang) {
                console.warn('_config.lang is not set');
            }

            if (_cfg.lang !== "en") {
                $.loadScript('/static/js/libs/i18n/jquery-ui-datepicker/datepicker-' + _cfg.lang +  '.js').done(function () {
                    init($scope);
                }).fail(function () {
                    init($scope);
                }) ;
            } else {
                init($scope);
            }
        });
    }
}());

app.modules.imgGridSlider = function ($scope) {
    var slickOptions = {
        dots: true,
        swipeToSlide: true,
        speed: 180,
        infinite: true,
        variableWidth: matchMedia('(max-width: 767px)').matches ? false: true,
        nextArrow: '<button type="button" class="slick-next icon-btn btn btn-primary slider__arrow" aria-label="Next"><span class="icon-btn__icon icon icon-arrow-right"></span></button>',
        prevArrow: '<button type="button" class="slick-prev icon-btn btn btn-primary slider__arrow" aria-label="Previous"><span class="icon-btn__icon icon icon-arrow-left"></span></button>',
    };

    $.loadScript('/static/build/js/libs/slick.min.js').done(function() {
        var $sliders = $scope.find('.js-img-grid-slider');

        $sliders.each(function () {
            var $slider = $(this);
            var $tabPaneParent = $slider.closest('.tab-pane');

            if(!$tabPaneParent || !$tabPaneParent.length) {
                initSlider($slider);
            } else {
                /*refresh the slider when it was hidden in a tab*/
                var $tabTrigger = $('[href="#' + $tabPaneParent.attr('id') + '"],[data-toggle=tab][data-target="#' + $tabPaneParent.attr('id') + '"]');
                $tabTrigger.one('shown.bs.tab', function () {
                    initSlider($slider);
                });
            }
        });
    });

    function initSlider($slider) {
        $slider.children().each(function () {
            $(this).css('display', 'block');
            $(this).width($(this).width());
        });

        $slider.slick(slickOptions);
    }
};

app.modules.tooltip = function ($scope) {
    $scope.find('.js-tooltip').tooltip();
};

app.modules.popover = function ($scope) {
    $scope.find('[data-toggle="popover"]').popover({
        placement: 'auto',
        trigger: 'focus'
    });
};

app.modules.contactBar = function ($scope) {
    $scope.find('.js-contact-bar').each(function () {
        var isOpen = false,
            didScroll,
            $contactBar = $(this),
            timeout = $contactBar.data('timeout'),
            $anchor = $($contactBar.data('anchor'));


        try {
            if (JSON.parse(window.sessionStorage.getItem('contactBarCloseCount')) >= 2) {
                window.sessionStorage.setItem('contactBarClose', true);
            }
        } catch(e){
            console.log(e);
        }

        $contactBar.find('.js-contact-bar__toggle').on('click', function () {
            if ($contactBar.hasClass('is-open')) {
                $contactBar.removeClass('is-open');

                var closeCount = window.sessionStorage.getItem('contactBarCloseCount') || 0;

                window.sessionStorage.setItem('contactBarCloseCount', JSON.parse(closeCount) + 1);

                if (closeCount >= 2) {
                    window.sessionStorage.setItem('contactBarClose', true);
                }

                isOpen = false;
            } else {
                $contactBar.addClass('is-open');
            }
        });

        try{
            if(!window.sessionStorage.getItem('contactBarClose')) {

                var t = setTimeout(function () {
                    $contactBar.addClass('is-open');
                    isOpen = true;

                    $(window).off('scroll');

                    clearTimeout(t);
                }, timeout)

                function scrollHandler() {
                    if (!isOpen) {
                        if ($anchor.offset().top + $anchor.outerHeight() < $(window).scrollTop()) {
                            $contactBar.addClass('is-open');
                            isOpen = true;

                            clearTimeout(t);
                        }
                    }
                }

                $(window).scroll(function (event) {
                    didScroll = true;
                });

                requestAnimationFrame(function animationFrameHandler() {
                    if (didScroll) {
                        scrollHandler();
                        didScroll = false;
                    }
                    requestAnimationFrame(animationFrameHandler);
                });
            }
        }catch(e){
            console.log(e);
        }
    });
};

app.modules.cartbox = function ($scope) {
    $scope.find('.js-cart-box').on('click', function (evt) {
        var $target = $(evt.target);
        if (!$target.is('a, button, input, label, select') &&
            !$target.closest('a, button, input, label, select').length){

            var $input = $(this).find('.js-cart-box__input');

            if ($input.is('[type="radio"],[type="checkbox"]')) {
                if ($input.is('[type="radio"]')) {
                    if (!($input.is(':checked'))) {
                        $input.prop('checked', !$input.prop('checked')).change();

                        /*trigger change event on other radios with the same name*/
                        var $radios = $('input[type="radio"][name="' + $input.attr('name') +'"]');

                        $.each($radios, function (index, radio) {
                            $(radio).trigger('change');
                        });
                    }
                } else {
                    $input.prop('checked', !$input.prop('checked')).change();
                }

                /*trigger validation*/
                if ($input.data('ParsleyFieldMultiple')) {
                    $.each($('[data-parsley-multiple="' + $input.data('parsleyMultiple') + '"]'), function () {
                        $(this).parsley().validate();
                    });
                } else if ($input.data('Parsley')) {
                    $(this).parsley().validate();
                }
            }
        }
    });

    $scope.find('.js-cart-box').on('change', function (evt) {
        var $cartbox = $(this);
        if ($cartbox.find('.js-cart-box__input').is(':checked')) {
            $cartbox.addClass('is-selected');
            $cartbox.find('.js-cart-box__collapse-detail').collapse('show');
        } else {
            $cartbox.removeClass('is-selected');
            $cartbox.find('.js-cart-box__collapse-detail').collapse('hide');
        }
    })
};


app.modules.handleDisposition = function ($scope) {
    $scope.find('.js-ajax-disposition').on('click', function (e) {

        e.preventDefault();

        var $form = $(this).closest('form'),
            ajaxAction = $(this).data('ajax-action'),
            id = $(this).data('carid') || '';

        if (id == 'all') {
            id = '';
        }

        function createDisposition() {
            console.log($form.serialize());
            if($form.find('#custom-offer-price' + id).length && $form.find('#custom-offer-price' + id).parsley().validate() !== true){
                return false;
            }

            var dispositionWindow = window.open('', ajaxAction);

            $.ajax(ajaxAction, {
                type: 'POST',
                data: $form.serialize(),
                cache: true
            }).done(function (data) {
                if(!data.url) {
                    dispositionWindow.location = "data:text/html;charset=utf-8,"+data;
                }else {
                    dispositionWindow.location = data.url;
                }
            }).fail(function (a,b,c) {
                console.error(a,b,c);
            });
        }

        if ($form.find('.js-leasing-input').length > 0) {
            var currentLeasingOffer = getCurrentLeasingOffer();

            for (var prop in currentLeasingOffer) {
                $form.find('.js-leasing-input[data-name="'+ prop +'"]').val(currentLeasingOffer[prop])
            }

            createDisposition();
        } else {
            createDisposition();
        }
    });

    var dispositionBtn = $scope.find('.js-ajax-email-disposition').on('click', function (e) {

        e.preventDefault();

        var $form = $(this).closest('form'),
            id = $(this).data('carid') || '';

        if (id == 'all') {
            id = '';
        }

        if($form.parsley().validate() !== true){
            return false;
        }

        if ($form.find('.js-leasing-input').length > 0) {
            var currentLeasingOffer = getCurrentLeasingOffer();

            for (var prop in currentLeasingOffer) {
                $form.find('.js-leasing-input[data-name="'+ prop +'"]').val(currentLeasingOffer[prop])
            }
        }

        var ajaxAction = $(this).data('ajax-action');
        var formData = new FormData($form[0]);
        // add files to formData
        var files = $form.find('#attachments' + id)[0].files;
        for(var i = 0; i < files.length; i++) {
            formData.append('attachments[]', files[i]);
        }

        if (!matchMedia('(max-width: 767px)').matches) {
            var dispositionWindow = window.open('', ajaxAction);
        }

        dispositionBtn.addClass('active');

        $.ajax(ajaxAction, {
            type: 'POST',
            data: formData,
            contentType: false,
            processData: false,
            cache: true
        }).done(function (data) {
            if (!matchMedia('(max-width: 767px)').matches) {
                // open disposition capture here ?
                dispositionWindow.location = data.url;
                // dispositionWindow.close();
            }

            dispositionBtn.removeClass('active');
            $('#email-sent-modal' + id).modal();
        }).fail(function (a, b, c) {
            console.log('fuuu');
        });
    });
};

app.modules.dependCheckbox = function ($scope) {
    $('.js-depend-checkbox').on('change', function () {
        var dependCheckbox = $(this).data('depending-checkbox');

        if($(this).is(':checked')) {
            $(dependCheckbox).removeAttr('hidden');
        } else {
            $(dependCheckbox).attr('hidden', true);
            $(dependCheckbox).find('input[type=checkbox]').prop('checked', false);
        }
    });
};

app.modules.toggleRequired = function ($scope) {
    $scope.find('.js-toggle-required').on('change', function () {
        var $form = $(this).closest('form'),
            $inputs = $form.find('input[data-depend-field]');

        $inputs.each(function () {
            var input = $(this),
                depends = input.data('depend-field').split(",");
            input.prop('required', false);
            input.closest('.form-group').find('.required-symbol').attr('hidden', true);

            for (var j = 0; j < depends.length; j++) {
                var checkboxes = $form.find('input[data-depend-id="' + depends[j] + '"]');
                for (var i = 0; i < checkboxes.length; i++) {
                    if(checkboxes[i].checked) {
                        if(depends[j] == $(checkboxes[i]).data('depend-id')) {
                            input.closest('.form-group').find('.required-symbol').attr('hidden', false);
                            input.prop('required', true);
                        }
                    }
                }
            }
        });
    });
};

app.modules.formPageView = function ($scope) {
    app.loadParsley().done(function () {
        var $forms = $scope.find('.js-virtual-pageview');

        if (!$forms || !$forms.length) {
            return;
        }

        $forms.each(function () {
            var $form = $(this);
            var url = $form.data('virtual-pageview');


            var leadsUserData = {
                address: {}
            }

            var isStepForm = $form.hasClass('js-step-form');
            $form.parsley().on('form:validate', function (formInstance) {
                if ($form.find('input[data-sha-input="email_address"]').val()) {
                    leadsUserData.sha256_email_address = toHash($form.find('input[data-sha-input="email_address"]').val());
                }
                if ($form.find('input[data-sha-input="phone_number"]').val()) {
                    leadsUserData.sha256_phone_number = toHash($form.find('input[data-sha-input="phone_number"]').val());
                }
                if ($form.find('input[data-sha-input="first_name"]').val()) {
                    leadsUserData.address.sha256_first_name = toHash($form.find('input[data-sha-input="first_name"]').val());
                }
                if ($form.find('input[data-sha-input="last_name"]').val()) {
                    leadsUserData.address.sha256_last_name = toHash($form.find('input[data-sha-input="last_name"]').val());
                }
                if ($form.find('input[data-sha-input="street"]').val()) {
                    leadsUserData.address.sha256_street = toHash($form.find('input[data-sha-input="street"]').val());
                }
                if ($form.find('input[data-sha-input="postal_code"]').val()) {
                    leadsUserData.address.postal_code = $form.find('input[data-sha-input="postal_code"]').val();
                }
                if ($form.find('input[data-sha-input="city"]').val()) {
                    leadsUserData.address.city = $form.find('input[data-sha-input="city"]').val();
                }

                if ($form.data('leads-user-data')) {
                    var data = $form.data('leads-user-data');
                    if (data.email_address) {
                        leadsUserData.sha256_email_address = toHash(data.email_address);
                    }
                    if (data.phone_number) {
                        leadsUserData.sha256_phone_number = toHash(data.phone_number);
                    }
                    if (data.first_name) {
                        leadsUserData.address.sha256_first_name = toHash(data.first_name);
                    }
                    if (data.last_name) {
                        leadsUserData.address.sha256_last_name = toHash(data.last_name);
                    }
                    if (data.street) {
                        leadsUserData.address.sha256_street = toHash(data.street);
                    }
                    if (data.postal_code) {
                        leadsUserData.address.postal_code = data.postal_code;
                    }
                    if (data.city) {
                        leadsUserData.address.city = data.city;
                    }
                }

                if (isStepForm && !$form.find('.js-step-form__step').last().hasClass('is-current')) {
                    return;
                }

                var isValid = formInstance.isValid();
                if(isValid) {
                    if(url !== "undefined") {
                        var trackingData = {
                            leadsUserData: leadsUserData
                        };

                        var trackingReferenceUrl = $form.data('trck-ref-url');
                        if( trackingReferenceUrl ) {
                            // note: replace async with promise (when -> then) ?
                            var jqxhr = $.ajax( trackingReferenceUrl, {
                                async:false
                            })
                            .done( function( data ) {
                                if( typeof data === 'object' ) {
                                    if( data.hasOwnProperty( 'identifier') ) {
                                        // add event data
                                        trackingData.reference = data.identifier;
                                    }

                                    if( data.hasOwnProperty( 'offerReference') ) {
                                        // add event data
                                        trackingData.gfz = data.offerReference;
                                    }

                                    if( data.hasOwnProperty( 'identifier') ) {
                                        // add hidden for backend tracking
                                        $('<input>').attr({
                                            type: 'hidden',
                                            name: '_trck_ref',
                                            value: data.identifier
                                        }).appendTo($form);
                                    }
                                }
                            } );
                        }

                        app.tracking.trackVirtualPageView( url, trackingData );
                    }

                    // Newsletter subscription checkbox
                    var $checkbox = $form.find('input[data-virtual-pageview]');
                    if($checkbox.is(':checked')) {
                        app.tracking.trackVirtualPageView( $checkbox.data('virtual-pageview'), { leadsUserData: leadsUserData } );
                    }
                }
            });
        });

    });
};

function toHash (ascii) {
    var mathPow = Math.pow;
    var maxWord = mathPow(2, 32);
    var lengthProperty = 'length'
    var i, j; // Used as a counter across the whole file
    var result = ''

    var words = [];
    var asciiBitLength = ascii[lengthProperty] * 8;

    //* caching results is optional - remove/add slash from front of this line to toggle
    // Initial hash value: first 32 bits of the fractional parts of the square roots of the first 8 primes
    // (we actually calculate the first 64, but extra values are just ignored)
    var hash = [];
    // Round constants: first 32 bits of the fractional parts of the cube roots of the first 64 primes
    var k = [];
    var primeCounter = k[lengthProperty];

    var isComposite = {};
    for (var candidate = 2; primeCounter < 64; candidate++) {
        if (!isComposite[candidate]) {
            for (i = 0; i < 313; i += candidate) {
                isComposite[i] = candidate;
            }
            hash[primeCounter] = (mathPow(candidate, .5) * maxWord) | 0;
            k[primeCounter++] = (mathPow(candidate, 1 / 3) * maxWord) | 0;
        }
    }

    ascii += '\x80' // Append Ƈ' bit (plus zero padding)
    while (ascii[lengthProperty] % 64 - 56) ascii += '\x00' // More zero padding
    for (i = 0; i < ascii[lengthProperty]; i++) {
        j = ascii.charCodeAt(i);
        if (j >> 8) return; // ASCII check: only accept characters in range 0-255
        words[i >> 2] |= j << ((3 - i) % 4) * 8;
    }
    words[words[lengthProperty]] = ((asciiBitLength / maxWord) | 0);
    words[words[lengthProperty]] = (asciiBitLength)

    // process each chunk
    for (j = 0; j < words[lengthProperty];) {
        var w = words.slice(j, j += 16); // The message is expanded into 64 words as part of the iteration
        var oldHash = hash;
        // This is now the undefinedworking hash, often labelled as variables a...g
        // (we have to truncate as well, otherwise extra entries at the end accumulate
        hash = hash.slice(0, 8);

        for (i = 0; i < 64; i++) {
            var i2 = i + j;
            // Expand the message into 64 words
            var w15 = w[i - 15], w2 = w[i - 2];

            // Iterate
            var a = hash[0], e = hash[4];
            var temp1 = hash[7]
                + (rightRotate(e, 6) ^ rightRotate(e, 11) ^ rightRotate(e, 25)) // S1
                + ((e & hash[5]) ^ ((~e) & hash[6])) // ch
                + k[i]
                // Expand the message schedule if needed
                + (w[i] = (i < 16) ? w[i] : (
                        w[i - 16]
                        + (rightRotate(w15, 7) ^ rightRotate(w15, 18) ^ (w15 >>> 3)) // s0
                        + w[i - 7]
                        + (rightRotate(w2, 17) ^ rightRotate(w2, 19) ^ (w2 >>> 10)) // s1
                    ) | 0
                );
            // This is only used once, so *could* be moved below, but it only saves 4 bytes and makes things unreadble
            var temp2 = (rightRotate(a, 2) ^ rightRotate(a, 13) ^ rightRotate(a, 22)) // S0
                + ((a & hash[1]) ^ (a & hash[2]) ^ (hash[1] & hash[2])); // maj

            hash = [(temp1 + temp2) | 0].concat(hash); // We don't bother trimming off the extra ones, they're harmless as long as we're truncating when we do the slice()
            hash[4] = (hash[4] + temp1) | 0;
        }

        for (i = 0; i < 8; i++) {
            hash[i] = (hash[i] + oldHash[i]) | 0;
        }
    }

    for (i = 0; i < 8; i++) {
        for (j = 3; j + 1; j--) {
            var b = (hash[i] >> (j * 8)) & 255;
            result += ((b < 16) ? 0 : '') + b.toString(16);
        }
    }
    return result;

}
// Only need for SHA256 Function
function rightRotate(value, amount) {
    return (value >>> amount) | (value << (32 - amount));
}

/*parsley*/
app.modules.parsley = function ($scope) {
    app.loadParsley().done(function () {
        var $forms = $scope.find('.js-parsley');

        if (!$forms || !$forms.length) {
            return;
        }

        $forms.parsley(app.modules.parsley.options);

        $forms.each(function () {
            var $form = $(this);

            $form.parsley().on('field:error', function() {
                var parsleyId = this.__id__;
                var fieldClass = this.__class__;

                if (fieldClass == 'ParsleyFieldMultiple') {
                    parsleyId = 'multiple-' + this.$element.data('parsley-multiple');
                }

                this.$element.attr({
                    'aria-invalid': "true",
                    'aria-describedby': 'parsley-id-'+ parsleyId
                });
            });

            $form.parsley().on('field:success', function() {
                this.$element.removeAttr('aria-invalid aria-describedby');
            });
        });

        window.Parsley
            .addValidator('fileType', {
                validateString: function(_value, fileTypes, parsleyInstance) {
                    var files = parsleyInstance.$element[0].files;
                    var allowedTypes = $(parsleyInstance.$element[0]).attr('accept').split(',');
                    allowedTypes = allowedTypes.map(function (type) {
                        return type.trim();
                    });
                    var isValid = true;
                    for (var i = 0; i < files.length; i++) {
                        if (allowedTypes.indexOf(files[i].type) === -1) {
                            isValid = false;
                            break;
                        }
                    }
                    return isValid;
                },
                messages: {
                    de: translate('form.general.file-type-error'),
                    en: translate('form.general.file-type-error')
                }
            });
    });
};

app.modules.parsley.options = {
    successClass: 'has-success',
    errorClass: 'has-error',
    classHandler: function (_el) {
        return _el.$element.closest('.form-group');
    },
    errorsContainer: function (_el) {
        var errorContainer = _el.$element.closest('.form-group').find('.form-errors');
        if (errorContainer && errorContainer.length > 0) {
            return errorContainer;
        }
    },
    // nur felder validieren die sichtbar sind
    excluded: "input[type=button], input[type=submit], input[type=reset], input[type=hidden], [disabled], :hidden"
};

(function () {
    var promise;

    app.loadParsley = function () {
        if (promise) {
            return promise;
        }

        promise = $.Deferred();

        $.loadScript("/static/build/js/libs/parsley.min.js").done(function () {
            if (_cfg.lang && _cfg.lang !== 'en') {
                $.loadScript("/static/build/js/libs/i18n/parsley/" + _cfg.lang + ".js").done(function () {
                    promise.resolve();
                }).fail(function () {
                    /*fallback if there is no package*/
                    promise.resolve();
                });
            } else {
                promise.resolve();
            }
        }).fail(function () {
            promise.reject();
        });

        return promise;
    };
}());

app.modules.videoJs = function ($scope) {
    app.modules.videoJs.id || (app.modules.videoJs.id = 1);
    $.loadScript('/static/build/js/libs/video.js').done(function (){
        $scope.find('.js-video-js').each(function () {
            var id = $(this).prop('id');
            if (!id) {
                id = 'video-js-id-' + app.modules.videoJs.id++;
                $(this).prop('id', id);
            }
            videojs(id);
        });
    });
};

app.modules.multiDropdown = function ($scope) {
    $scope.find('.js-multi-dropdown').each(function () {
        var defaultText = $(this).children().find('.dropdown--select__btn__text').text();

        function changeButtonText($this) {
            var checkedCheckboxes = $this.find('input[type=checkbox]:checked').closest('.js-multi-dropdown__checkbox').find('.js-multi-dropdown__checkbox-label');

            var title = $.map(checkedCheckboxes, function (title) {
                return $(title).text();
            }).join(', ');

            var label = $(checkedCheckboxes[0]).text(),
                otherCount = checkedCheckboxes.length - 1;

            if(checkedCheckboxes.length > 1) {
                label = $(checkedCheckboxes[0]).text() + ' + ' + otherCount;
            }

            if(checkedCheckboxes.length != 0){
                $this.closest('.dropdown').children().find('.dropdown--select__btn__text').text(label);
                $this.closest('.dropdown').children('.dropdown--select__btn').attr('title', title);
            }else {
                $this.closest('.dropdown').children().find('.dropdown--select__btn__text').text(defaultText);
                $this.closest('.dropdown').children('.dropdown--select__btn').attr('title', defaultText);
            }
        }

        $(this).on('change dropdown_change', function () {
            changeButtonText($(this));
        });

        changeButtonText($(this));

        //prevent dropdown close on content click
        $(this).find('.dropdown-menu__content').on('click', function (evt) {
            $(this).closest('.dropdown').addClass('open');
        });

        //prevent dropdown close on range slider change
        $(this).on('dropdown.range.slider.changed', function (evt, sliderObj) {
            $(this).one('hide.bs.dropdown', function (evt) {
                evt.preventDefault();
                evt.stopPropagation();
            });
        });
    });
};

app.modules.subSelect = function ($scope) {
    $scope.find('.js-sub-select').each(function () {
        var $subSelect = $(this);
        var $observingInputs = $($subSelect.data('depend-on'));
        var url = $subSelect.data('url');

        var pendingRequest;
        $observingInputs.on('change', function () {
            var currentValue = $subSelect.val();
            $subSelect.attr('disabled', 'disabled');

            if(pendingRequest) {
                pendingRequest.abort();
            }

            pendingRequest = $.ajax(url, {
                data: $observingInputs.serialize(),
                cache: true,
                dataType: 'html'
            }).done(function (data) {
                $subSelect.empty();
                $subSelect.append(data);
                $subSelect.val(currentValue);
                if (!$subSelect.val()) {
                    $subSelect.val($subSelect.find('option:first-child').val());
                }
            }).always(function () {
                pendingRequest = null;
                $subSelect.attr('disabled', null);
            });
        });
    });
};

app.modules.switchView = function ($scope) {
    var viewOption = $scope.find('.js-switch-view');
    viewOption.on('change', function () {
        $(this).closest('.form').submit();
    });
};

app.modules.switchViewAjax = function ($scope) {
    var viewOption = $scope.find('.js-switch-view');

    viewOption.each(function () {
        $(this).on('change', function () {
            var data = $(this).closest('.form').serializeArray(),
                url = $(this).closest('.form').data('url'),
                $target = $( $(this).closest('.form').data('replace-div') );
            $.ajax({
                method: "POST",
                url: url,
                data: data
            }).done(function(content) {
                var state = $target.find(':input').serializeArray();
                $target.html(content);

                $.each(state, function (index, obj) {
                    var $input = $target.find('[name="' + obj.name + '"][value="' + obj.value + '"]');
                    $input.attr('checked', true);
                });

                app.initModules($target);
            });
        });
    });
};

app.modules.tablePdfForm = function($scope) {
    $triggerForms = $scope.find('.js-pdf-trigger');
    $sourceForms = $scope.find('.js-pdf-source');

    $triggerForms.on('submit', function(e) {
        e.preventDefault();

        var action = $(this).attr('action');

        var idlist = '';

        $sourceForms.each(function() {
            var _idlist = $(this).serialize();
            if(_idlist && idlist) {
                idlist += '&'+_idlist;
            } else if(_idlist) {
                idlist += _idlist;
            }
        });

        var url = action;
        if(idlist) {
            url += '?' + idlist;
        }

        window.open(url, 'pdf');

    });

};

app.modules.switchTableView = function($scope) {
    var viewOption = $scope.find('.js-switch-view');


    viewOption.each(function () {
        $(this).on('change', function () {
            var table = $(this).closest('.table-wrapper').find('.js-table'),
                items = table.find('.hide-to');
            if($(this).val() === "hide") {
                items.each(function() {
                    $(this).removeClass('hidden');
                });
            }
            else if ($(this).val() === "show") {
                items.each(function() {
                    $(this).addClass('hidden');
                });
            }
        });
    });
};

app.modules.sortableTable = function ($scope) {
    $scope.find('.js-sortable-table').each(function () {
        var $table = $(this);
        var $tableBody = $table.find('.js-sortable-table__body');

        var rows = [];
        $tableBody.find('tr').each(function () {
            var $row = $(this);

            var values = $row.find('td').toArray().map(function (ele) {
                return $(ele).data('value') || $(ele).text();
            });

            rows.push({
                values: values,
                $element: $row
            });
        });

        console.log(rows);

        var $btns = $table.find('.js-sortable-table__btn');
        console.log('$btns', $btns);
        $btns.on('click',  function () {
            var $this = $(this);
            if ($this.hasClass('is-selected-asc')) {
                $btns.removeClass('is-selected-asc')
                    .removeClass('is-selected-desc');
                $this.addClass('is-selected-desc');
                sortBy($tableBody, rows, $this.parent().index(), 'desc');
            } else {
                $btns.removeClass('is-selected-asc')
                    .removeClass('is-selected-desc');
                $this.addClass('is-selected-asc');
                sortBy($tableBody, rows, $this.parent().index(), 'asc');
            }
        });


        //all-pdf checkboxes
        $table.find('.js-trigger-all-ids').change(function() {
            var isChecked = $(this).is(':checked');
            var $form = $(this).parents('form');
            var $formCheckboxes = $form.find('input[name^=idlist]');


            if(isChecked) {
                $formCheckboxes.prop('checked', true);
            } else {
                $formCheckboxes.prop('checked', false);
            }


        });

    });

    function sortBy($tableBody, rows, valueIndex, type) {
        var sorted = rows.slice().sort(function (a, b) {
            a = a.values[valueIndex];
            b = b.values[valueIndex];

            if (type === 'asc') {
                if (a < b) {
                    return -1;
                }
                if (a > b) {
                    return 1;
                }
            } else {
                if (a < b) {
                    return 1;
                }
                if (a > b) {
                    return -1;
                }
            }

            return 0;
        });

        $tableBody.empty();
        sorted.forEach(function (row) {
            $tableBody.append(row.$element);
        });
    }
};

app.modules.unblu = function() {

    var $unbluChatEngageWidget = $('#unbluChatEngageWidget');

    //query the API for an available agent and show the engageWidget
    unbluAPI.core.agent.availability.AgentInformationManager.getAgentAvailabilityState({
        onSuccess: function(state) {
            //console.log(state);
            //state = 'AVAILABLE' | 'UNAVAILABLE'
            if(state == 'AVAILABLE' || /[?&]forceunblu=/.test(location.search)) {
                console.log('agent available');

                unbluAPI.core.visitor.session.Session.isSessionActive({
                    onSuccess: function(active) {
                        if(!active) {
                            //only display the widget if no session is already active
                            $unbluChatEngageWidget.css('display', 'block');
                            $('#mobileUnbluBar').css('display', 'block');
                        } else {
                            console.log('session already active');
                        }
                    },
                    onFailure: function(error) {
                        console.log(error);
                    }
                });

            } else {
                console.log('agent not available');
            }
        }, onFailure: function(failReason) {
            console.log('Failed to check for agent availability:', failReason);
        }
    });

    var $form = $('#unbluChatEngageWidget').find('form');
    $form.on('submit', function(e) {

        var name = $form.find('input[name="chatusername"]').val();
        console.log(name);

        e.preventDefault();
        if(unbluAPI) {
            unbluAPI.core.visitor.session.Session.startChatSession(name, {
                onSuccess: function(sessionInfo) {
                    $unbluChatEngageWidget.css('display', 'none');
                    $('#mobileUnbluBar').css('display', 'none');
                },
                onFailure: function(error) {
                    console.log(error);
                }
            });
        }

    });

};

// app.modules.affixTable = function($scope) {
//
//     $scope.find('.js-affix-table').each(function () {
//         var $table = $(this),
//             $header = $table.find('thead');
//
//         var width = $table.width();
//         $(window).on('resize', function() {
//             width = $table.width();
//             $header.css({
//                 'width' : width
//             });
//         });
//
//         $header.find('th').each(function () {
//             $(this).css('width', $(this).outerWidth())
//         });
//
//         $table.prepend($header.clone().css('visibility' , 'hidden'));
//
//         $header.on('affix.bs.affix', function () {
//             $header.css({
//                 'width' : width,
//                 'z-index' : '2'
//             });
//         });
//
//         $header.affix({
//             offset: {
//                 top: function () {
//                     return $table.offset().top;
//                 },
//                 bottom: function () {
//                     return window.document.body.scrollHeight - $table.offset().top - $table.height()
//                         + ($table.outerHeight() - $table.height()); /*because bootstrap uses height instead of the correct outerHeight */
//                 }
//             }
//         });
//     });
// };

(function () {
    app.modules.watchListGetInfo = function($scope){
        var $addButtons = $scope.find('.js-watchList-add');
        if ($addButtons && $addButtons.length) {
            getWatchlistIndex().map(function (listId) {
                var $listAddBtns;

                if (listId === 'watchList') {
                    $listAddBtns = $addButtons.filter('[data-watch-list-id="watchList"], :not([data-watch-list-id])')
                } else {
                    $listAddBtns = $addButtons.filter(
                        '[data-watch-list-id="' + listId.replace('watchList-', '') + '"]'
                    );
                }

                getWatchlistById(listId).map(function (obj) {
                    $listAddBtns.filter('[data-id="' + obj.dataId + '"]').addClass('is-added');
                });
            });
        }

        var newCount = getWatchlistCount();

        if(newCount > 0){
            $('.js-watchList-count').text('(' + newCount + ')');
        }
        if(newCount > 0 && matchMedia('(min-width: 768px)').matches) {
            $('.js-watchList-count').text('(' + newCount + ')').closest('.watchList-info').addClass('is-active');
        }
    };

    (function () {
        var $target = $(_config.watchListTarget);

        app.watchListGet = function () {
            console.log('add server list');
            if(_cfg['watchListSet']) {
                if (Array.isArray(_cfg['watchListSet'])) {
                    watchList = window.localStorage.getItem('watchList') || [];
                    watchList = JSON.parse(watchList);

                    var items = _cfg.watchListSet;

                    $.each(items, function (index, id) {
                        var result = $.grep(watchList, function (el) {
                            return el.dataId == parseInt(id)
                        });

                        if (result.length == 0) {
                            var newItem = {
                                dataId: parseInt(id)
                            };

                            watchList.push(newItem);
                            window.localStorage.setItem('watchList', JSON.stringify(watchList));
                        }

                        app.watchListGet.loadItems();
                        app.modules.watchListGetInfo();
                    });
                } else {
                    Object.keys(_cfg['watchListSet']).forEach(function (listName) {
                        _cfg['watchListSet'][listName].forEach(function (newId) {
                            watchListAdd(newId, listName);
                        })
                    });
                }
            }

            console.log('load items');
            app.watchListGet.loadItems();
        };

        app.watchListGet.loadItems = function () {
            var paramLists = getWatchlistIndex().map(function (listId) {
                return getWatchlistById(listId).map(function (obj, index) {
                    if (listId == 'watchList') {
                        return 'dataId[' + index + ']=' + obj.dataId;
                    } else {
                        return listId.replace('watchList-', '') + '[' + index + ']=' + obj.dataId;
                    }
                })
            });

            var paramas = [].concat.apply([], paramLists).join('&');

            if(_config.syncWatchlistItems) {
                var url = _config.syncWatchlistItems;

                $.ajax({
                    method: "GET",
                    url: url,
                    data: paramas
                }).done(function(content) {
                    var validIds = content;
                    var index = getWatchlistIndex();
                    window.localStorage.setItem(index, JSON.stringify(validIds));

                    //todo remove items from watchlist
                });
            }


            if(watchList){
                var url = _config.watchListUrl;

                $.ajax({
                    method: "GET",
                    url: url,
                    data: paramas
                }).done(function(content) {
                    $target.html(content);

                    app.initModules($target);
                });
            }
        }
    }());

    function watchListAdd(id, listId) {
        var storageKey = getStorageKey(listId);
        var watchList = JSON.parse(window.localStorage.getItem(storageKey)) || [];
        addWatchlistToIndex(storageKey);

        var newItem = {
            dataId: id
        };

        var isAlreadyInList = !!watchList.filter(function (obj) {
            return obj.dataId === id
        }).length;

        if (!isAlreadyInList) {
            watchList.push(newItem);

            window.localStorage.setItem(storageKey, JSON.stringify(watchList));

            $('.js-watchList-count').text('(' + getWatchlistCount() + ')').closest('.watchList-info').addClass('is-active');

            if(matchMedia('(max-width: 767px)').matches) {
                var t = setTimeout(function () {
                    $('.watchList-info').removeClass('is-active');
                    clearTimeout(t);
                }, 4000);
            }
        }


    }

    function getStorageKey(listId) {
        return (listId && listId !== 'watchList') ? ('watchList-' + listId) :  'watchList'
    }

    function addWatchlistToIndex(listId) {
        var watchListIndex;
        var watchListIndexString = localStorage.getItem('watchListIndex');
        if (watchListIndexString) {
            watchListIndex = JSON.parse(watchListIndexString);
            if (watchListIndex.indexOf(listId) < 0) {
                watchListIndex.push(listId);
            }
        } else {
            watchListIndex = [listId];
        }
        localStorage.setItem('watchListIndex', JSON.stringify(watchListIndex));
    }

    function watchListRemove(id, listId) {
        var storageKey = listId ? ('watchList-' + listId) :  'watchList';
        var watchList = JSON.parse(window.localStorage.getItem(storageKey));

        console.log('watchlist before remove', watchList);

        //remove item from array
        watchList = watchList.filter(function(el){
            return el.dataId != id;
        });

        window.localStorage.setItem(storageKey, JSON.stringify(watchList));

        console.log('watchlist after remove', watchList);

        var newCount = getWatchlistCount();

        if(newCount <= 0){
            $('.js-watchList-count').text('').closest('.watchList-info').removeClass('is-active');
        }else {
            $('.js-watchList-count').text('(' + newCount + ')')
                .closest('.watchList-info').addClass('is-active');

            if(matchMedia('(max-width: 767px)').matches) {
                var t = setTimeout(function () {
                    $('.watchList-info').removeClass('is-active');
                    clearTimeout(t);
                }, 4000);
            }
        }

        app.watchListGet.loadItems();
    }

    app.modules.watchList = (function () {

        return function ($scope) {
            $scope.find('.js-watchList-add').on('click', function (evt) {
                evt.preventDefault();
                evt.stopImmediatePropagation();

                if ($(this).hasClass('is-added')) {
                    $(this).removeClass('is-added');
                    watchListRemove($(this).data('id'), $(this).data('watch-list-id'));
                } else {
                    $(this).addClass('is-added');
                    watchListAdd($(this).data('id'), $(this).data('watch-list-id'));
                }

            });

            $scope.find('.js-watchlist-remove-list').on('click', function (evt) {
                evt.preventDefault();
                evt.stopImmediatePropagation();

                var listId = $(this).data('watch-list-id'),
                    items = $(this).data('watch-list-items');

                $.each(items, function (index, id) {
                    watchListRemove(id, listId);
                });
                window.location.reload(true);
            });
        };
    }());

    function getWatchlistCount() {
        /* get all lists */
        var watchListIndex = getWatchlistIndex();

        // calculate length of all lists
        return watchListIndex.map(function (storageKey) {
            var string = localStorage.getItem(storageKey);
            if (string) {
                return JSON.parse(string).length;
            }
            return 0;
        }).reduce(function (sum, count) {
            return sum + count;
        }, 0);
    }

    function getWatchlistIndex() {
        var watchListIndex = [];
        var watchListIndexString = localStorage.getItem('watchListIndex');
        if (watchListIndexString) {
            watchListIndex = JSON.parse(watchListIndexString);
        }
        if (watchListIndex.indexOf('watchList') < 0) {
            watchListIndex.push('watchList')
        }

        return watchListIndex;
    }

    function getWatchlistById(id) {
        var string = localStorage.getItem(id);
        if (string) {
            return JSON.parse(string);
        }
        return [];
    }
}());



app.modules.removeUpload = function ($scope) {
    $scope.find('.js-remove-upload').on('click', function (evt) {
        evt.preventDefault();

        var $target = $($(this).data('target'));

        $.ajax({
            url: $(this).data('action'),
            method: 'post',
            cache: false
        }).done(function (response) {
            $target.html(response);
            app.initModules($target);

        }).fail(function (data) {
            console.log('ajax form fail', data);
        });
    });
};

app.modules.ajaxForm = function ($scope) {
    $scope.find('.js-ajax-form').each(function () {
        var $this = $(this),
            trigger = $this.data('trigger') ? $this.data('trigger') : 'submit';

        $this.on(trigger, function (evt) {
            evt.preventDefault();

            submitForm($this.closest('.js-ajax-form'), null, null, evt);
        });
    });

    $scope.find('.js-ajax-form__submit').on('click', function (evt) {
        evt.preventDefault();

        submitForm($(this).closest('.js-ajax-form'));
    });

    $scope.find('.js-ajax-form__submit-data').on('click', function (evt) {
        evt.preventDefault();

        var data = $(this).data('ajax-form-data') ? $(this).data('ajax-form-data') : {};

        submitForm($(this).closest('.js-ajax-form'), data, $(this).data('ajax-form-url'), evt);
    });

    function addSearchParamsToUrl(url, searchParams) {
        url = new URL(url, location.origin);

        var searchParamsArray = Array.from(searchParams);
        searchParamsArray.forEach(function (param) {
            url.searchParams.delete(param[0]);
        })

        searchParamsArray.forEach(function (param) {
            url.searchParams.append(param[0], param[1])
        })

        return url;
    }


    function submitForm($form, data, url, evt) {
        var $target = $($form.data('target')),
            $loader = $target.prev('.js-ajax-form__loading').length ? $target.prev('.js-ajax-form__loading') : $form.find('.js-ajax-form__loading'),
            processData = true,
            contentType = undefined,
            formData = $form.data('form-data') ? new FormData($form[0]) : $form.serialize();

        //change ajax options if input type file
        if($form.find('input[type="file"]').length) {
            processData = false;
            contentType = false;
            formData = new FormData($form[0]);
        }

        if (data) {
            processData = false;
            contentType = false;

            if (!formData) {
                formData = new FormData($form[0]);
            }

            $.each(Object.entries(data), function (index, item) {
                formData.append(item[0], item[1])
            });
        }

        if ($form.data('form-data')) {
            processData = false;
            contentType = false;
        }

        $loader.removeClass('hidden').attr('hidden', null);

        if ($form.data('add-url-params')) {
            var url = new URL(location.href);
            url.searchParams.delete('page');
            url = addSearchParamsToUrl(url, new URLSearchParams(formData));

            history.replaceState(history.state, document.title, url);
        }

        $.ajax({
            url: url ? url : $form.prop('action') || $form.data('action'),
            method: $form.prop('method'),
            data: formData,
            cache: false,
            headers: {Ajax: 1},
            contentType: contentType,
            processData: processData
        }).done(function (response) {

            console.log($target)
            $target.html(response);
            app.initModules($target);

            $loader.addClass('hidden').attr('hidden', 'hidden');

            //sorry
            if ($form.data('reload-after-submit')) {
                if (evt && $(evt.target).data('reload-after-submit') === false) {
                    return
                }
                window.location.reload();
            }

        }).fail(function (data) {
            console.log('ajax form fail', data);
        });
    }
};

app.modules.ajaxPaging = function ($scope) {
    $scope.find('.js-filter-form-paging a').on('click', function (evt) {
        evt.preventDefault();

        var $target = $($(this).closest('.js-paging').data('target'));

        $.ajax({
            url: $(this).attr('href'),
            data: 'page=' + $(this).data('page'),
            method: 'GET',
            headers: {Ajax: 1}
        }).done(function (response) {
            $target.html(response);
            app.initModules($target);

        }).fail(function (data) {
            console.log('ajax paging fail', data);
        });
    });
};

app.modules.searchAgent = function ($scope) {
    $scope.find('.js-search-agent').on('submit', function (evt) {
        var $form = $(this),
            $modal = $($form.data('target'));

        if (!$form.is('.js-parsley') || $(this).parsley().validate()) {
            $modal.modal('show');
            evt.preventDefault();
            $.ajax($(this).attr('action'), {
                dataType: 'html',
                cache: 'false',
                method: 'POST',
                data: $form.serialize()
            }).done(function (result) {
                var $result = $modal.find('.js-search-agent__result');
                $result.empty().html(result);

                //close console search agent
                $('.js-search-agent-overlay').removeClass('is-open');
                $('.js-search-agent-overlay').closest('.console__item').removeClass('is-open');
                window.sessionStorage.setItem('hideSearchAgent', true);

                app.initModules($result);
            }).fail(function (a,b,c) {
                console.error(a,b,c);
            });
        }
    });
};

/**
 * handle price tag section
 *
 * @param scope
 */
app.modules.printPriceTag = function ($scope) {
    $scope.find('.equipment-options>ul>li').click(function () {
        var text = $(this).html();
        var $textarea = $(this).closest('.form-group').find('textarea');
        if($textarea.length) {
            if($textarea.val()) {
                $textarea.val($textarea.val() + '\n');
            }
            $textarea.val($textarea.val() + text.trim());
        }
    });

    $scope.find('.js-print-pricetag').click(function (e) {
        // $scope.find('#print-price-tag').click(function(e){
        e.preventDefault();
        var id = this.getAttribute('data-carid');
        var $form = $(this).closest('form');
        var ajaxAction = $(this).data('ajax-action');
        var formData = new FormData($form[0]);

        // This handles printing of multiple price tags like in the merkliste.
        // Each vehicle has a separate form that allows the user to customise the output.
        // The form data is serialised and appended to the POST data so we can pass it along to the Controller.
        var dataIds = $form.find('input[name="dataId[]"]') || {};
        dataIds.each(function () {
            var $this = $(this);
            var carId = $this.val();
            var carForm = $('form#price-tag-form' + carId);

            formData.append('car-form-' + carId, carForm.serialize());
        });

        if($form.parsley(app.modules.parsley.options).validate() !== true){
            return false;
        }

        if (id == 'all') {
            id = '';
        }

        var pdfWindow = window.open('', ajaxAction);
        window.focus();

        $.ajax(ajaxAction, {
            type: 'POST',
            data: formData,
            contentType: false,
            processData: false,
            cache: true
        }).done(function (data) {

            pdfWindow.location = data.url;
            window.focus();
            $('#price-tag-printed-modal' + id).modal();
        }).fail(function (a, b, c) {
            console.log(a,b,c);
        });
    });

    $scope.find('.price-tag-print-success').click(function(e){

        e.preventDefault();
        var id = this.getAttribute('data-carid');
        if (id == 'all' || !id) {
            id = '';
        }
        $(this).closest('#price-tag-printed-modal' + id).modal('hide');

        var $form = $('#price-tag-form' + id);
        var ajaxAction = $(this).data('ajax-action');
        var formData = new FormData($form[0]);

        $.ajax(ajaxAction, {
            type: 'POST',
            data: formData,
            contentType: false,
            processData: false,
            cache: true
        }).done(function (data) {

            if(data.success) {
                $('#print-status-label' + id).html(data.success);
            }else {
                alert(data.error);
            }

        }).fail(function (a, b, c) {
            console.log(a, b, c);
        });
    });
};

app.modules.qrCodeAvailability = function ($scope) {
    $scope.find('.js-qr-code-validation');
    app.loadParsley().done(function () {
        window.Parsley.addAsyncValidator('qrCodeAvailability', function (xhr) {
            return xhr.responseJSON.data;
        }, '/action/pappas-portal_car/qr-code-availability');
    });
};

/**
 * handle price tag section
 *
 * @param scope
 */
app.modules.portalReservation = function ($scope) {

    $scope.find('.js-reservation').click(function (e) {

        e.preventDefault();
        var $form = $(this).closest('form');
        var ajaxAction = $(this).data('ajax-action');
        var formData = new FormData($form[0]);
        var mode = $(this).data('mode') ? $(this).data('mode') : 'reserve';


        var $nameInput = $form.find('input[name="customer-name"]');
        var $emailInput = $form.find('input[name="customer-email"]');
        var $expiryInput = $form.find('input[name="reservation-expiry-date"]');
        var $reservationStatus = $form.find('#reservation-status');
        var $reservationButton = $form.find('#portal-make-reservation');
        var $cancelButton = $form.find('#portal-cancel-reservation');

        // Modal
        var $modal = $form.next('.js-vehicle-reservation__modal');
        var $modalLoading = $modal.find('.js-vehicle-reservation__modal-loading');
        var $modalError = $modal.find('.js-vehicle-reservation__modal-error');
        var $modalSuccess = $modal.find('.js-vehicle-reservation__modal-success');

        if(mode === 'reserve' && $form.parsley(app.modules.parsley.options).validate() !== true){
            return false;
        }

        $modalError.attr('hidden', 'hidden');
        $modalSuccess.attr('hidden', 'hidden');
        $modalLoading.attr('hidden', null);
        $modal.modal('show');

        //disable buttons, inputs and status

        $.ajax(ajaxAction, {
            type: 'POST',
            data: formData,
            contentType: false,
            processData: false,
            cache: false
        }).done(function (data) {

            if(data.success) {
                var success = JSON.parse(data.success);

                if(success['customer-name']) { $nameInput.val(success['customer-name']); }
                if(success['customer-email']) { $emailInput.val(success['customer-email']); }
                if(success['reservation-expiry']) { $expiryInput.val(success['reservation-expiry']);}

                $modalSuccess.attr('hidden', null);

                window.location.reload();

            } else if(data.error) {
                $modalError.append('<p>'+data.error+'</p>');

                console.log($modalError);
                $modalError.attr('hidden', null);
            }

            //do succes stuff
            //enable buttons, inputs and status

        }).fail(function (a, b, c) {
            console.log(a,b,c);
            $modalError.attr('hidden', null);
        }).always(function () {
            $modalLoading.attr('hidden', 'hidden');
        });
    });

};

app.modules.disableDropdownFormSubmit = function ($scope) {
    $scope.on('click', '.dropdown-menu button[type="submit"]', function(e) {
        e.preventDefault();
    });
};



app.modules.autoFormUpdater = function ($scope) {
    $scope.find('.js-auto-form-updater').each(function () {
        var $ele = $(this);
        var $form = $ele.find('.js-auto-form-updater__form');
        var $submit = $form.find('.js-auto-form-updater__submit');
        var ajaxAction = $form.data('ajax-action');

        var updateFnc = updateFncCreator($ele, {});

        if (!$form.length) {
            console.warn('app.modules.vehicleAjaxSearch: Could not find js-auto-form-updater__form');
            return;
        }

        if (!ajaxAction) {
            console.warn('app.modules.vehicleAjaxSearch: Could not find data-ajax-action on ', $form);
            return;
        }

        var pendingRequest;
        function sendAjaxRequest() {
            if (pendingRequest) {
                pendingRequest.abort();
            }

            $form.addClass('is-loading');
            $submit.prop("disabled", true);

            pendingRequest = $.ajax(ajaxAction, {
                data: $form.serialize(),
                dataType: 'json',
                cache: true
            }).done(function (newState) {
                $form.removeClass('is-loading');
                $submit.prop("disabled", false);
                pendingRequest = null;
                updateFnc(newState);
            }).fail(function (a,b,c) {
                $form.removeClass('is-loading');
                console.error(a,b,c);
            });
        }

        // Sorry, just a quick and dirty implementation as a proof of concept of sorts...
        sendAjaxRequest();

        $form.on('change', function (evt) {
            if($(evt.target).parents().hasClass('js-multi-dropdown')) {
                return;
            } else {
                sendAjaxRequest();
            }
        });

        $form.find('.js-multi-dropdown').on('hidden.bs.dropdown', function (evt) {
            var timeout = setTimeout(function () {
                if(!$(evt.target).hasClass('open')) {
                    sendAjaxRequest();
                }
                clearTimeout(timeout);
            }, 1);
        });

        $form.find('.js-reset-form').on('click', function (evt) {
            $form.find('input[type="checkbox"]').each(function (index, item) {
                $(item).prop('checked', false);
                $(item).removeAttr('checked');
            });
            $form.find('.js-range-slider__slider').each(function() {
                var $elem = $(this);
                var min = $elem.data('min') - $elem.data('step');
                var max = $elem.data('max') + $elem.data('step');
                $elem[0].noUiSlider.updateOptions({
                    start: [ min, max ],
                    range: {
                        'min': [min],
                        'max': [max]
                    },
                    step: $elem.data('step')
                });
                $elem[0].noUiSlider.reset();
            });
            sendAjaxRequest();
        });
    });

    function updateFncCreator($ele, initialState) {
        var prevState = initialState;
        var prevMultiSelects = getMultiSelects(initialState);

        return function (state) {
            if (typeof state.count != "undefined") {
                if (state.count !== prevState.count) {
                    $ele.find('.js-auto-form-updater__count').text(state.count);
                    $('.js-auto-form-updater__count[data-id="' + $ele.attr('id') + '"]').text(state.count);
                }
            }

            var $checkboxLists = $ele.find('.js-auto-form-updater__checkbox-list');
            if (typeof state.CheckboxLists != "undefined") {
                var prevCheckboxListsById = getCheckboxListsById(prevState);
                var checkboxListsById = getCheckboxListsById(state);
                $.each(checkboxListsById, function (listId, list) {
                    var elementsToAdd = [];

                    $.each(list, function (checkboxId, checkboxObj) {
                        if (!prevCheckboxListsById
                            || !prevCheckboxListsById[listId]
                            || !prevCheckboxListsById[listId][checkboxId]) {
                            elementsToAdd.push($.extend({id: checkboxId}, checkboxObj));
                        }
                    });

                    var elementsToRemove = [];
                    if (prevState && prevCheckboxListsById && prevCheckboxListsById[listId]){
                        $.each(prevCheckboxListsById[listId], function (checkboxId, checkboxObj) {
                            if (!checkboxListsById[listId][checkboxId]) {
                                elementsToRemove.push({id: checkboxId});
                            }
                        })
                    }

                    var $checkboxList = $checkboxLists.filter('[data-id="' + listId + '"]');
                    $checkboxList.removeClass('hidden').attr('hidden', null);

                    if($checkboxList.closest('.js-auto-form-updater__group')) {
                        $checkboxList.closest('.js-auto-form-updater__group').removeClass('hidden').attr('hidden', null);
                    }

                    if($checkboxList.closest('.js-auto-form-update__disable-group')) {
                        $checkboxList.closest('.js-auto-form-update__disable-group').removeClass('is-disabled');
                    }

                    $.each(elementsToAdd, function (index, checkboxObj) {
                        var $checkbox = $checkboxList.find('[data-id="' + checkboxObj.id + '"]');
                        if ($checkbox && $checkbox.length) {
                            $checkbox.replaceWith(checkboxObj.html);
                        } else {
                            $checkboxList.append(checkboxObj.html);
                        }
                    });

                    $.each(elementsToRemove, function (index, checkboxObj) {
                        $checkboxList.find('[data-id="' + checkboxObj.id + '"]')
                            .addClass('hidden')
                            .attr('hidden', 'hidden');
                    });
                });
            }

            if (typeof prevState.CheckboxLists !== "undefined") {
                $.each(prevCheckboxListsById, function (listId, list) {
                    if (!checkboxListsById || !checkboxListsById[listId]) {
                        var $checkboxList = $checkboxLists.filter('[data-id="' + listId + '"]');
                        $checkboxList.addClass('hidden').attr('hidden', 'hidden');
                        $checkboxList.find('[data-id]')
                            .addClass('hidden')
                            .attr('hidden', 'hidden');

                        if($checkboxList.closest('.js-auto-form-updater__group')) {
                            $checkboxList.closest('.js-auto-form-updater__group').addClass('hidden').attr('hidden', 'hidden');
                        }

                        if($checkboxList.closest('.js-auto-form-update__disable-group')) {
                            $checkboxList.closest('.js-auto-form-update__disable-group').addClass('is-disabled');
                        }
                    }
                });
            }

            var multiSelects = getMultiSelects(state);
            var $multiSelects = $ele.find('.js-multi-dropdown');
            $.each(multiSelects, function (multiSelectKey, multiSelect) {
                var $mulitSelect = $multiSelects.filter('[data-id="' + multiSelectKey + '"]');
                if (!$mulitSelect || !$mulitSelect.length) {
                    cls.warn('Could not find .js-multi-dropdown with [data-id="' + multiSelectKey + '"] in', $ele);
                    return;
                }

                var hasCheckboxes = false;
                $.each(prevMultiSelects[multiSelectKey], function (listKey, checkboxList) {
                    if (!multiSelects[listKey]) {
                        $mulitSelect.find('.js-multi-dropdown__list[data-id="' + listKey + '"]').addClass('is-empty');
                        multiSelects[listKey] = {};
                    }
                });

                $.each(multiSelect, function (listKey, checkboxList) {
                    var $checkboxList = $mulitSelect.find('.js-multi-dropdown__list[data-id="' + listKey + '"]');
                    var $checkboxes = $checkboxList.find('.js-multi-dropdown__checkbox');

                    if (!$checkboxList || !$checkboxList.length) {
                        cls.warn('Could not find .js-multi-dropdown__list with [data-id="' + multiSelectKey + '"] in', $mulitSelect);
                        return;
                    }

                    if (Object.keys(checkboxList).length === 0) {
                        /*is empty*/
                        $checkboxList.addClass('is-empty');
                    } else {
                        hasCheckboxes = true;
                        $checkboxList.removeClass('is-empty');
                    }

                    var elementsToAdd = [];
                    var elementsToChange = [];
                    var elementsToDelete = [];

                    $.each(checkboxList, function (checkBoxId, checkbox) {
                        if (
                            !prevMultiSelects
                            || !prevMultiSelects[multiSelectKey]
                            || !prevMultiSelects[multiSelectKey][listKey]
                            || !prevMultiSelects[multiSelectKey][listKey][checkBoxId]
                        ) {
                            elementsToAdd.push($.extend({id: checkBoxId}, checkbox));
                        } else {
                            if (checkbox.count
                                !== prevMultiSelects[multiSelectKey][listKey][checkBoxId].count) {
                                elementsToChange.push($.extend(
                                    {id: checkBoxId},
                                    checkbox
                                ));
                            }
                        }
                    });

                    if (prevMultiSelects && prevMultiSelects[multiSelectKey]) {
                        $.each(prevMultiSelects[multiSelectKey], function (checkboxListKey, checkboxList) {
                            $.each(checkboxList, function (checkBoxId, checkbox) {
                                if ( !multiSelect[checkboxListKey]
                                    || !multiSelect[checkboxListKey][checkBoxId]
                                ) {
                                    elementsToDelete.push({id: checkBoxId});
                                }
                            });
                        });
                    }

                    /*Removes*/
                    $.each(elementsToDelete, function (index, ele) {
                        $checkboxes.filter('[data-id="' + ele.id + '"]')
                            .addClass('hidden')
                            .attr('hidden', 'hidden');
                    });

                    /*Adds*/
                    $.each(elementsToAdd, function (index, ele) {
                        var $checkbox = $checkboxList.find('[data-id="' + ele.id + '"]');
                        if ($checkbox && $checkbox.length) {
                            $checkbox.replaceWith(ele.html);
                        } else {
                            $checkboxList.append(ele.html);
                        }
                    });

                    /*Counter updates*/
                    $.each(elementsToChange, function (index, ele) {
                        $checkboxes.filter('[data-id="' + ele.id + '"]').find('.js-counter').text(ele.count);
                    });
                });

                var $mulitSelectBtn = $mulitSelect.find('.js-multi-dropdown__btn');
                if (hasCheckboxes) {
                    $mulitSelectBtn.attr('disabled', null);
                } else {
                    $mulitSelectBtn.attr('disabled', 'disabled');
                }

                $mulitSelect.trigger('dropdown_change');
            });

            var selects = getSelects(state);

            var $selects = $ele.find('select');
            for (var selectKey in selects) {

                var $select = $selects.filter('[data-id="' + selectKey + '"]');
                $select.empty();
                $select.append(selects[selectKey]);
                if ($select.children().length) {
                    $select.attr('disabled', null);
                    if (!$select.val()) {
                        $select.val($select.find('option:first-child').val());
                    }
                } else {
                    $select.attr('disabled', 'disabled');
                }

            }

            var ranges = getRanges(state);
            var $rangeSliders = $ele.find('.js-range-slider__slider');

            for (var rangeKey in ranges) {
                var elem = ranges[rangeKey];
                var $rangeSlider = $rangeSliders.filter('[data-parent="' + rangeKey + '"]');

                if (elem.slider && $rangeSlider[0]) {
                    var min = elem.slider.min - elem.slider.step;
                    var max = elem.slider.max + elem.slider.step;
                    var slider = $rangeSlider[0].noUiSlider;

                    var $from = $rangeSlider.closest('.js-range-slider').find('.js-range-inputs__from');
                    var $to = $rangeSlider.closest('.js-range-slider').find('.js-range-inputs__to');

                    if(_cfg.lang === "hu") {
                        $from.attr('placeholder', min + ' ' + translate('from'));
                        $to.attr('placeholder', elem.slider.max + ' ' + translate('to'));
                    } else {
                        $from.attr('placeholder', translate('from') + ' ' + min);
                        $to.attr('placeholder', translate('to') + ' ' + elem.slider.max);
                    }

                    var from = $from.val() || min;
                    var to = $to.val() || max;

                    slider.updateOptions({
                        start: [from, to],
                        range: {
                            'min': [min],
                            'max': [max]
                        },
                        step: elem.slider.step
                    });
                }
            }

            app.modules.rangeSliderSelect($scope);

            prevState = state;
            prevMultiSelects = getMultiSelects(prevState);
        }
    }

    function getMultiSelects (state) {
        return $.extend(
            {},
            state.multiSelects,
            state.FilterCategory,
            state.FilterMultiRelation,
            state.FilterMultiSelect,
            state.FilterMultiSelectFromMultiSelect
        );
    }

    function getSelects (state) {
        return $.extend(
            {},
            state.selects,
            state.FilterNumberRange,
            state.FilterNumberRangeMultiple
        )
    }

    function getRanges (state) {
        return $.extend(
            {},
            state.FilterNumberRange,
            state.FilterNumberRangeMultiple
        )
    }

    function getCheckboxListsById(state) {
        if (!state) {
            return {};
        }

        return state.CheckboxLists;
    }
};

var translate = (function () {
    var missingTranslations = [];

    function translate(string) {
        if (typeof _translations !== 'object') {
            console.warn('Global translation object _translations missing');
            return string;
        }

        if (!_translations[string]) {
            if($.inArray(string, missingTranslations) === -1) {
                console.warn('Could not translate "' + string + '". Translation not found in translation object', _translations);
                missingTranslations.push(string);
            }

            return string;
        }

        return _translations[string];
    }

    function getMissingTranslations() {
        return missingTranslations;
    }

    window.getMissingTranslations = getMissingTranslations;

    return translate;
}());

app.modules.scrollingMap = (function() {
    if(matchMedia('(max-width: 767px)').matches) {
        /*don't init on mobile*/
        return;
    }
    if (!_cfg.scrollingMap) {
        return;
    }

    var map = $('.js-google-map[data-active-listpoi=true]');
    var mapParent = map.closest('.row');
    var viewportHeight = window.innerHeight;
    var mapParentHeight;
    var offset;
    var poiListElement =  $('.scrolling-map__pois');

    if(matchMedia('(max-width: 991px)').matches) {
        viewportHeight = window.innerHeight;
    }

    $(window).on('load', function(){
        init($('body'));
        $(window).on('scroll', scrollHandler);
    });

    function scrollHandler() {
        // offset = mapParent.offset().top - 67;
        offset = mapParent.offset().top;
        mapParentHeight = mapParent.outerHeight();

        if(matchMedia('(max-width: 991px)').matches) {
            offset = mapParent.offset().top;
        }
        //add fixed position at start of list
        if ($(window).scrollTop() >= offset && mapParentHeight + mapParent.offset().top > $(window).scrollTop() + window.innerHeight && !map.hasClass('is-fixed')){
            map.addClass('is-fixed');
            map.removeClass('is-bottom');
        }else if ($(window).scrollTop() < offset && map.hasClass('is-fixed')) {
            map.removeClass('is-fixed');
        }
        //remove fixed position at end of list
        if (mapParentHeight + mapParent.offset().top < $(window).scrollTop() + window.innerHeight && map.hasClass('is-fixed')) {
            map.removeClass('is-fixed');
            map.addClass('is-bottom');
        }
    }

    function init($scope) {
        $(window).off('scroll', scrollHandler);
        var poiListHeight = poiListElement.outerHeight();

        mapParentHeight = mapParent.outerHeight();

        map.css('height', viewportHeight);
        map.removeClass('is-bottom');

        if (viewportHeight <= poiListHeight) {
            offset = mapParent.offset().top;

            if(matchMedia('(max-width: 991px)').matches) {
                offset = mapParent.offset().top;
            }

            if($(window).scrollTop() >= offset && mapParentHeight + mapParent.offset().top > $(window).scrollTop() + window.innerHeight){
                map.removeClass('is-bottom');
                map.addClass('is-fixed');
            } else if (mapParentHeight + mapParent.offset().top < $(window).scrollTop() + window.innerHeight) {
                map.addClass('is-bottom').removeClass('is-fixed');
            }

            $(window).on('scroll', scrollHandler);

        }
    }

    return init;
} ());

app.modules.getCurrentLocation = function ($scope) {
    $scope.find('.js-geolocation').on('click', function (evt) {
        var $this = $(this);
        evt.preventDefault();

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(getLatLng);
        } else {
            console.error("Geolocation is not supported by this browser.");
        }

        function getLatLng(position) {
            var lat = position.coords.latitude,
                lng = position.coords.longitude;

            $this.closest('.form-group').find('.form-control').val('');

            $('.js-google-autocomplete__input-lat').val(lat);
            $('.js-google-autocomplete__input-lng').val(lng);

            if(matchMedia('(min-width: 768px)').matches) {
                $('.js-google-map').data('google-map').getGeoLocation(lat, lng);
            }
        }
    });
};

app.googleMap = (function () {
    var apiLoaded = false,
        apiLoading = false,
        callbacks = [];

    function loadScript() {
        apiLoading = true;
        var script = document.createElement("script");
        script.type = "text/javascript";
        if (_cfg['googleMapAPIKey']) {
            script.src = "https://maps.googleapis.com/maps/api/js?key=" + _cfg.googleMapAPIKey + "&callback=app.googleMap.apiLoadedCallback&libraries=places";
        } else {
            script.src = "https://maps.googleapis.com/maps/api/js&callback=app.googleMap.apiLoadedCallback&libraries=places";
        }
        document.body.appendChild(script);
    }

    function apiLoadedCallback() {
        for(var i= 0, callback; callback = callbacks[i]; i++) {
            callback();
        }

        apiLoading = false;
        apiLoaded = true;
    }

    function loadApi(callback) {
        if (apiLoaded) {
            callback();
        } else {
            callbacks.push(callback);

            if (!apiLoading) {
                loadScript();
            }
        }
    }

    return {
        apiLoadedCallback: apiLoadedCallback,
        loadApi: loadApi
    };
}());

app.modules.googleMap = (function () {
    function GoogleMap (element) {
        var self = this;
        this.element = $(element);
        this.canvas = element.find('.js-google-map__canvas')[0];
        this.map = null;
        this.marker = [];
        this.geo = [];


        if(typeof $(this.canvas).data('longitude') != 'undefined'){
            self.geo['longitude'] = $(this.canvas).data('longitude');
            self.geo['latitude'] = $(this.canvas).data('latitude');
        } else {
            self.geo['longitude'] = 12.6370814;
            self.geo['latitude'] = 47.3932376;
        }


        app.googleMap.loadApi(function () {
            self.initMap();
        });



        $.loadScript("/static/build/js/filterform.min.js").done(function () {
            app.filterStore.subscribe(function () {
                var baseUrl = _config.filterStoreUrlMap;
                self.fetchMarker(baseUrl);
            });
        });

    }

    GoogleMap.prototype.initMap = function () {
        var self = this;

        var mapOptions = {
            zoom: 17,
            center: new google.maps.LatLng(self.geo['latitude'], self.geo['longitude']),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            minZoom: 5,
            disableDefaultUI: true,
            scrollwheel: false
        };

        this.markerOptions = {
            size: new google.maps.Size(40, 58),
            origin: new google.maps.Point(0,0),
            anchor: new google.maps.Point(20, 54),
            icon: {
                path: google.maps.SymbolPath.CIRCLE,
                fillColor: '#fff',
                strokeColor: '#fff',
                strokeWeight: 0,
                fillOpacity: 0,
                scale: 10
            }
        };

        self.map = new google.maps.Map(self.canvas, mapOptions);

        this.element.on('click', '.js-google-map__zoom-in', function () {
            self.map.setZoom(++self.map.zoom);
        });

        this.element.on('click', '.js-google-map__zoom-out', function () {
            self.map.setZoom(--self.map.zoom);
        });

        this.poiData = window[this.element.data('poi')];
        if (this.poiData) {
            this.setMarker(this.poiData);
        }

        var mapStyle = [
            {
                "featureType": "administrative.province",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 65
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 51
                    },
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 30
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 40
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "hue": "#ffff00"
                    },
                    {
                        "lightness": -25
                    },
                    {
                        "saturation": -97
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "lightness": -25
                    },
                    {
                        "saturation": -100
                    }
                ]
            }
        ];

        self.map.set('styles', mapStyle );

        if(this.element.data('active-listpoi')) {
            $('.js-active-map').on('mouseenter', function() {
                var markerId = $(this).data('poi-id');
                self.activeMarker(markerId);
            });
        }

        if(this.element.data('geolocator')) {
            $('.js-google-autocomplete__input').on('input', function () {
                if($(this).val().length > 2) {
                    self.autoComplete($(this).attr('id'), $(this).data('restrictions'), $(this).closest('.js-google-autocomplete').find('.js-google-autocomplete__input-lat'), $(this).closest('.js-google-autocomplete').find('.js-google-autocomplete__input-lng'));
                }
            });

            if ($('.js-google-autocomplete__input-lat').val().length > 0 && $('.js-google-autocomplete__input-lng').val().length > 0) {
                var lat = $('.js-google-autocomplete__input-lat').val(),
                    lng = $('.js-google-autocomplete__input-lng').val();

                self.getGeoLocation(lat, lng);
            }
        }

        this.element.data('google-map', this);

        //if map is in accordion
        var accordion = this.element.closest('.collapse');
        if (accordion && accordion.length>0) {
            accordion.one('shown.bs.collapse', function () {
                google.maps.event.trigger(self.map, 'resize');
                self.centerMap();
            });
        }
    };

    GoogleMap.prototype.setMarker = function (data) {
        var self = this;

        //remove marker
        for (var i = 0, marker; marker = self.marker[i]; i++ ) {
            if(marker.dataId != 'myLocationMarker'){
                marker.setMap(null);
            }
        }

        self.marker = self.marker.filter(function(el){
            return el.dataId == 'myLocationMarker';
        });

        $.loadScript('/static/build/js/libs/markerwithlabel_packed.js').done(function(){
            for (var i= 0, poi; poi = data[i]; i++) {
                if (poi.lat && poi.lng) {
                    // var markerOptions;

                    var poiPosition = new google.maps.LatLng(poi.lat, poi.lng),
                        newMarker = new MarkerWithLabel({
                            map: self.map,
                            position: poiPosition,
                            icon: self.markerOptions.icon,
                            dataId: poi.id,
                            defaultIcon: self.markerOptions.icon,
                            labelContent: "<div class='google-map__marker text-center'>" +
                                "<span class='" + poi.labelClass + "'></span>" +
                                "</div>",
                            labelAnchor: new google.maps.Point(17, 54),
                            labelClass: 'google-map__marker-wrapper',
                            dataInfoBox: poi.infoBox
                        });

                    self.marker.push(newMarker);
                    self.centerMap(); //need for markerwithlabel

                    google.maps.event.addListener(newMarker, 'click', function() {
                        var isMarkerClick = true;
                        if (this.isActive) {
                            self.deactivateAllMarker();
                        } else {
                            self.deactivateAllMarker();
                            self.activeMarker(this.dataId, isMarkerClick);
                        }
                    });

                    if (poi.infoBox) {
                        (function (poi, newMarker) {
                            google.maps.event.addListener(newMarker, 'click', function() {
                                $.loadScript("/static/build/js/libs/google.maps.infobox.js").done(function () {
                                    self.map.setCenter(newMarker.getPosition());
                                    self.showDetail(poi.id, newMarker);
                                });
                            });
                        }(poi, newMarker));
                    }
                }
            }
        });
    };

    GoogleMap.prototype.fetchMarker = function (baseUrl) {
        var self = this,
            pendingRequest;

        if (pendingRequest) {
            pendingRequest.abort();
        }


        var url = baseUrl + (baseUrl.indexOf('?') < 0 ? '?': ':') + $.param(app.filterStore.getSerializedParams());

        return pendingRequest = $.ajax(url, {
            cache: true,
            dataType : 'json',
            headers: {Ajax: 1, Format: 'json'}
        }).done(function (data, textStatus, jqXHR) {
            pendingRequest = null;
            self.setMarker(data);

        }).fail(function (response,errorType,errorText) {
            console.log(response,errorType,errorText)
        });
    };

    GoogleMap.prototype.autoComplete = function (id, restrictions, latInput, lngInput) {
        var self = this;

        var myLocation_input = new google.maps.places.Autocomplete(document.getElementById(id), {componentRestrictions: {country: restrictions}});
        myLocation_input.bindTo('bounds', self.map);

        myLocation_input.addListener('place_changed', function() {
            var place = myLocation_input.getPlace();
            if (!place.geometry) {
                console.warn("Autocomplete's returned place contains no geometry");
                return;
            } else {
                self.setMyLocation(place.geometry.location);
                $(latInput).val(place.geometry.location.lat());
                $(lngInput).val(place.geometry.location.lng());
            }

        });
    };

    GoogleMap.prototype.getGeoLocation = function (lat, lng) {
        var latlng = new google.maps.LatLng(lat, lng);

        this.setMyLocation(latlng);
    };

    GoogleMap.prototype.setMyLocation = function (latlng) {
        var self = this;

        //remove marker from map
        for (var i = 0, marker; marker = self.marker[i]; i++) {
            if(marker.dataId == 'myLocationMarker') {
                marker.setMap(null);
            }
        }

        self.marker = self.marker.filter(function(el){
            return el.dataId !== 'myLocationMarker';
        });

        $.loadScript('/static/build/js/libs/markerwithlabel_packed.js').done(function() {
            var newMarker = new MarkerWithLabel({
                map: self.map,
                position: latlng,
                icon: self.markerOptions.icon,
                dataId: 'myLocationMarker',
                defaultIcon: self.markerOptions.icon,
                labelContent: "<div class='google-map__marker google-map__marker--myLocation text-center'>" +
                    "<span class='icon icon-location-full text-primary'>" +
                    "<span class='icon icon-coordinates text-white'></span>" +
                    "</span>" +
                    "</div>",
                labelAnchor: new google.maps.Point(17, 54),
                labelClass: 'google-map__marker-wrapper'
            });

            self.marker.push(newMarker);

            var latlngbounds = new google.maps.LatLngBounds();
            latlngbounds.extend(latlng);

            self.map.setCenter(latlngbounds.getCenter());
            self.map.setZoom(10);
        });

    };

    GoogleMap.prototype.centerMap = function () {
        google.maps.event.trigger(this.map, 'resize');
        var latlngs = [];

        for (var i= 0, marker; marker = this.marker[i]; i++) {
            latlngs.push(marker.getPosition());
        }

        // Zoom/center map to fit all marker
        if (latlngs.length === 1) {
            this.map.setCenter(latlngs[0]);
        } else {
            var latlngbounds = new google.maps.LatLngBounds();
            for (var i= 0, pos; pos = latlngs[i]; i++) {
                latlngbounds.extend(pos);
            }
            this.map.setCenter(latlngbounds.getCenter());
            this.map.fitBounds(latlngbounds);
        }
    };

    GoogleMap.prototype.showDetail = function (id, marker) {
        var self = this;

        if (this.detailView && this.detailView.markerId && this.detailView.markerId === id) {
            this.closeDetail();
            return;
        }

        this.closeDetail();

        var detailContent = marker.dataInfoBox;

        var myOptions = {
            content: detailContent
            ,pixelOffset: new google.maps.Size(-272, 40)
            ,boxStyle: {
                width: "545px"
            }
            ,boxClass: "infobox google-map__infobox"
            //,closeBoxURL: "/static/img/content/google-close.png"
        };

        this.detailView = new InfoBox(myOptions);
        this.detailView.open(this.map, marker);

        this.detailView.markerId = id;
    };

    GoogleMap.prototype.closeDetail = function () {
        if (this.detailView && this.detailView.close) {
            this.detailView.close();
        }
        this.detailView = null;
    };

    GoogleMap.prototype.deactivateAllMarker = function() {
        var self = this;

        for (var i = 0, marker; marker = self.marker[i]; i++) {
            marker.isActive = false;
            marker.labelClass = 'google-map__marker-wrapper';
            try {
                marker.label.setStyles(); //Force label to redraw (makes update visible)
            }
            catch (e) {
                // Ignore any exceptions
            }
        }

        $('.js-active-map').removeClass('is-active');
    };

    GoogleMap.prototype.activeMarker = function(markerId, isMarkerClick) {
        var self = this;
        self.deactivateAllMarker();

        for (var i = 0, marker; marker = self.marker[i]; i++) {
            if (marker.dataId == markerId){
                var activeMarker = self.marker[i];

                activeMarker.isActive = true;
                activeMarker.labelClass = 'google-map__marker-wrapper' + ' is-active';
                try {
                    activeMarker.label.setStyles(); //Force label to redraw (makes update visible)
                }
                catch (e) {
                    // Ignore any exceptions
                }

                if(isMarkerClick) {
                    var poiTeaser = $('.js-active-map[data-poi-id=' + activeMarker["dataId"] + ']');

                    function scrollToPostion() {
                        if(matchMedia('(max-width: 767px)').matches) {
                            return;
                        }

                        var poiTeaserOffset = poiTeaser.offset().top - 121,
                            poiTeaserHeight = poiTeaser.outerHeight();


                        if(app.affixNavBar.isInDefaultState() == true) {
                            poiTeaserOffset = poiTeaser.offset().top
                        }

                        if($(window).scrollTop() >= poiTeaserOffset){
                            if (app.affixNavBar) {
                                app.affixNavBar.disable(!app.affixNavBar.isInDefaultState());
                            }

                            $('html, body').animate({
                                scrollTop: poiTeaserOffset
                            }, 600, function () {
                                if (app.affixNavBar) {
                                    app.affixNavBar.enable();
                                }
                            });
                        }else if(poiTeaserHeight + poiTeaser.offset().top > $(window).scrollTop() + window.innerHeight) {
                            $('html, body').animate({
                                scrollTop: poiTeaser.offset().top + poiTeaserHeight - window.innerHeight
                            }, 600);
                        }
                    }

                    if(poiTeaser.length !=0){
                        scrollToPostion();
                        $(poiTeaser).addClass('is-active');
                    }
                }
            }
        }
    };

    function initScope($scope) {
        $scope.find('.js-google-map').each(function () {
            var $this = $(this);
            if (window.Cookiebot && Cookiebot.consent.statistics) {
                new GoogleMap($this);
                $this.find('.js-google-map__hint').attr('hidden', true);
            } else {
                $this.find('.js-google-map__hint').attr('hidden', false);
            }

            window.addEventListener('CookiebotOnAccept', function (e) {
                if (window.Cookiebot && Cookiebot.consent.statistics) {
                    $this.find('.js-google-map__hint').attr('hidden', true);
                    new GoogleMap($this);
                }
            }, false);

            $this.find('.js-google-map__hint-allow').on('click', function () {
                if (window.Cookiebot) {
                    Cookiebot.show();
                }
            });
        });
    }

    return initScope;
}());

app.filterForm = function () {
    $.loadScript('/static/build/js/filterform.min.js');
};

app.modules.googleAutoCompleteXs = function($scope) {
    var $input = $scope.find('.js-google-autocomplete-xs');

    app.googleMap.loadApi(function () {
        $input.on('input', function () {
            if($(this).val().length > 3) {
                new google.maps.places.Autocomplete(document.getElementById($(this).attr('id'), {componentRestrictions: {country: $(this.data('restrictions'))}}));
            }
        });
    });
};

app.modules.consentLoad = function($scope) {
    var $this = $scope.find('.js-consent-load'),
        $allowBtn = $this.find('.js-consent-load__hint-allow'),
        $hint = $this.find('.js-consent-load__hint');

    if (window.Cookiebot && Cookiebot.consent.statistics) {
        $hint.attr('hidden', true);

        if($this.find('.js-consent-load__src')) {
            $this.find('.js-consent-load__src').attr('src', $this.find('.js-consent-load__src').data('src'));
        }
    } else {
        $hint.attr('hidden', false);
    }

    window.addEventListener('CookiebotOnAccept', function (e) {
        if (window.Cookiebot && Cookiebot.consent.statistics) {
            $hint.attr('hidden', true);

            if($this.find('.js-consent-load__src')) {
                $this.find('.js-consent-load__src').attr('src', $this.find('.js-consent-load__src').data('src'));
            }
        }
    }, false);

    $allowBtn.on('click', function () {
        if (window.Cookiebot) {
            Cookiebot.show();
        }
    });
};

app.ratingDialog = function () {

    var $starRating = $('.js-star-rating');

    var $dialog = $('.js-rating-dialog');
    var $loadingScreen = $dialog.find('.js-rating-dialog__loading');
    var id = $dialog.data('rating-id');
    if (!id) {
        console.warn('.js-rating-dialog does not have an id. "data-rating-id" was ', id);
        return;
    }

    var hasAlreadyVoted = false;
    try {
        hasAlreadyVoted = localStorage.getItem('ratingDialogHasVoted-' + id);
    } catch (e) {}

    if (hasAlreadyVoted) {
        $('.js-rating-dialog__rating-form').addClass('hidden').attr('hidden', 'hidden');
        $('.js-rating-dialog__already-voted').removeClass('hidden').attr('hidden', null);
    } else {
        $('.js-rating-dialog__rating-btn').on('click', function (evt) {
            evt.preventDefault();

            $('.js-rating-dialog__rating-form').addClass('hidden').attr('hidden', 'hidden');
            $loadingScreen.removeClass('hidden')
                .attr('hidden', null)
                .focus();

            $.ajax ($(this).data('href'), {
                cache: false
            }).done(function (result) {
                $starRating.empty();
                $starRating.append(result['updated-rating']);

                $loadingScreen.empty();
                $loadingScreen.append(result['user-message']);

                $dialog.one('hidden.bs.modal', function () {
                    $loadingScreen.addClass('hidden').attr('hidden', 'hidden');
                    $('.js-rating-dialog__already-voted').removeClass('hidden').attr('hidden', null);
                });

                try {
                    localStorage.setItem('ratingDialogHasVoted-' + id, true);
                } catch (e) {}
            });


        });
    }
};

app.mobileNav = function () {
    if(matchMedia('(max-width: 767px)').matches) {
        var mobileNavPlaceholder = $('#mobile-nav-placeholder'),
            mobileNav = $('#main-nav').clone();

        mobileNavPlaceholder.replaceWith(mobileNav);

        $('.js-navbar-toggle').on('tap', function () {
            if(!$(this).hasClass('is-open')){
                $('.mobile-nav').addClass('is-open');
                $(this).addClass('is-open');
                $('html').addClass('has-overflow-hidden');
            }else {
                $(this).closest('.navbar-header').find('.navbar-header__search').removeClass('is-open');
                $('.mobile-nav').removeClass('is-open');
                $(this).removeClass('is-open');
                $('html').removeClass('has-overflow-hidden');
            }
        }).on('click', function (evt) {
            evt.preventDefault();
        });

        mobileNav.find('.js-toggle-subnav').on('tap', function(evt){
            evt.preventDefault();
            if($(this).closest('li').hasClass('is-open')){
                $(this).closest('li').removeClass('is-open');
                $(this).closest('.mobile-nav__content').removeClass('has-open-subnav')
            }else {
                $(this).closest('ul').children().each(function () {
                    $(this).removeClass('is-open');
                    $(this).closest('.mobile-nav__content').removeClass('has-open-subnav')
                });
                $(this).closest('li').addClass('is-open');
                $(this).closest('.mobile-nav__content').addClass('has-open-subnav')
            }
        });
    }
};

app.touchNav = function () {
    if (matchMedia('(max-width: 767px)').matches) {
        return;
    }

    var mainNavItems = $('.navbar .navbar-nav li'),
        mainNavLinks = $('.navbar .navbar-nav li a');

    mainNavLinks.on('touchend', function (evt) {
        if (window.TouchEvent && evt.originalEvent instanceof TouchEvent) {
            var parent = $(this).closest('li');

            if (!parent.hasClass('is-open')) {
                evt.preventDefault();
                evt.stopImmediatePropagation();
                $(this).closest('ul').find('li').removeClass('is-open');
                parent.addClass('is-open');

                $('body').on('click', bodyClickHandler);
            }
        }
    });

    mainNavLinks.on('keydown', function(evt) {
        if(evt.keyCode == 40 || evt.keyCode == 38 || evt.keyCode == 32){
            evt.preventDefault();
            $(this).parent().addClass('is-open');
            $('body').on('keyup', escKeyHandler);
        } else if (evt.keyCode == 9 && !$(this).parent().hasClass('is-open')) {
            mainNavItems.removeClass('is-open');
            $('body').off('keyup', escKeyHandler);
        }
    });

    function escKeyHandler (evt){
        if(evt.keyCode == 27){
            mainNavItems.removeClass('is-open');
            $('body').off('keyup', escKeyHandler);
        }
    }

    function bodyClickHandler (evt) {
        if ($(evt.target).parents('.navbar-nav').length < 1) {
            evt.preventDefault();
            mainNavItems.removeClass('is-open');
            $('body').off('tap', bodyClickHandler);
        }
    }
};

function disableBodyScroll () {
    var $body = $('body');
    $body.css({
        'overflow': 'hidden',
        'padding-right': window.innerWidth - $body.width()  + 'px'
    });
}

function enableBodyScroll () {
    $('body').css({
        'overflow': '',
        'padding-right': ''
    });
}

function throttle (fnc, time) {
    var timeout;

    return function () {
        if (timeout) {
            clearTimeout(timeout);
        }

        timeout = setTimeout(function () {
            fnc.call(this);
            clearTimeout(timeout);
        }.bind(this), time);
    };
}

app.mainSearch = function () {
    $('.js-main-search__toggle').on('click', function (evt) {
        evt.preventDefault();
        var searchOverlaySelector = $(this).data('target') || $(this).attr('href');
        var $searchOverlay = $(searchOverlaySelector);

        if (!$searchOverlay || !$searchOverlay.length) {
            console.warn('Could not open search overlay "' + searchOverlaySelector + '". Element not found' );
            return;
        }

        $searchOverlay.toggleClass('is-shown');

        var overlayId = $searchOverlay.attr('id');
        var $toogles = $('.js-main-search__toggle[aria-controls="' + overlayId + '"]');

        if ($searchOverlay.hasClass('is-shown')) {
            if (app.affixNavBar) {
                // todo
                app.affixNavBar.disable(!app.affixNavBar.isInDefaultState());
            }
            $toogles.attr('aria-expanded', 'true');
            disableBodyScroll();

            var timeout = setTimeout(function () {
                /* timeout is needed because some browsers don't allow focusing a element
                if it is not visible */
                $searchOverlay.find('.js-main-search__input').focus();
                clearTimeout(timeout);
            }, 500);
        } else {
            if (app.affixNavBar) {
                app.affixNavBar.enable();
            }
            $toogles.attr('aria-expanded', 'false');
            enableBodyScroll();
        }
    });

    // var pendingSearchRequest;
    // $('.js-main-search__input').on('input', throttle(function () {
    // 	var value = $(this).val();
    // 	var $overlay = $(this).closest('.js-main-search__overlay');
    // 	var $form = $overlay.find('.js-main-search__form');
    // 	var $results = $overlay.find('.js-main-search__results');
    // 	var $loadingScreen = $overlay.find('.js-main-search__result-loading');
    // 	var ajaxAction = $form.data('ajax-action');
    //
    // 	if (pendingSearchRequest) {
    // 		pendingSearchRequest.abort();
    // 	}
    //
    // 	if (value && value.length >= 3) {
    //        $loadingScreen.removeAttr('hidden');
    //        $results.prop('hidden', 'hidden');
    //
    // 		pendingSearchRequest = $.ajax(ajaxAction, {
    // 			cache: true,
    // 			data: $form.serialize(),
    // 			dataType: 'html'
    // 		}).done(function (result) {
    // 			$results.empty();
    // 			$results.append(result);
    //
    //            $results.removeAttr('hidden');
    //            $loadingScreen.prop('hidden', 'hidden');
    // 		});
    // 	} else {
    //        $loadingScreen.prop('hidden', 'hidden');
    //        $results.prop('hidden', 'hidden');
    //
    // 		$results.empty();
    // 	}
    // }, 300));
};

app.modules.shariff = function($scope){
    var shariff = $scope.find('.js-shariff');

    $.loadScript('/static/build/js/libs/shariff.min.js').done(function () {
        shariff.each(function () {
            new Shariff($(this), {
                services: 'facebook, linkedin, twitter, mail, pinterest',
                buttonStyle: 'icon'
            });
        });
    });
};


app.modules.vehicleImgUpload = (function () {
    var pdfImages = 0;
    function init($scope) {
        var container = $scope.find('.js-vehicle-img-upload');

        $.loadScript("/static/js/libs/jquery-ui-sortable.min.js").done(function () {
            $.loadScript("/static/js/libs/jquery.ui.touch-punch.min.js").done(function () {
                container.each(function () {
                    var $imgContainer = $(this).find('.js-vehicle-img-upload__imgs');

                    $imgContainer.sortable({
                        opacity: 0.8,
                        tolerance: "pointer",
                        items: ".js-vehicle-img-upload__img",
                        handle: ".js-vehicle-img-upload__img-move",
                        revert: true,
                        cancel: "input,textarea,button,select,option,label",
                        update: function(vt, ui) {
                            $imgContainer.find('.js-vehicle-img-upload__img').each(function (index, item) {
                                $(item).find('.js-vehicle-img-upload__img-index').val(index);
                            });
                        }
                    });
                    $imgContainer.disableSelection();
                });
            });
        });

        var pdfCheckbox = $scope.find('.js-vehicle-img-upload__img-pdf');

        pdfImages = $scope.find('.js-vehicle-img-upload__img-pdf:checked').length + 1;
        checkCheckboxStates();


        function checkCheckboxStates() {
            pdfImages = $('.js-vehicle-img-upload__img-pdf:checked').length +1;

            if (pdfImages <= 5) {
                pdfCheckbox.each(function () {
                    $(this).prop('disabled', false);
                });
            } else {
                pdfCheckbox.each(function () {
                    if (!$(this).is(':checked')) {
                        $(this).prop('disabled', true);
                    }
                });
            }
        }
        pdfCheckbox.on('change', function (evt) {
            checkCheckboxStates();
        });

        container.each(function () {
            var $form = $(this);
            var $resultContainer = $form.find('.js-vehicle-img-upload__result');
            var $imgContainer = $form.find('.js-vehicle-img-upload__imgs');
            var $modal = $form.find('.js-vehicle-img-upload__modal');
            var $modalLoading = $form.find('.js-vehicle-img-upload__modal-loading');
            var $modalError = $form.find('.js-vehicle-img-upload__modal-error');
            var $modalRequest = $form.find('.js-vehicle-img-upload__request-modal');
            var $modalRequestError = $form.find('.js-vehicle-img-upload__request-modal-error');
            var toDelete = [];
            // var imgs = [];

            $form.find('.js-vehicle-img-upload__input').on('change', function () {
                unloadMessage.add();

                var input = this;

                //add imgs
                $.each(input.files, function (index, file) {
                    var dataUrlReader = new FileReader();

                    dataUrlReader.onload = function (e) {
                        var exif = EXIF.readFromBinaryFile(base64ToArrayBuffer(e.target.result));

                        // rotate Img
                        var rotatedSrc = e.target.result;
                        var degrees = 0;
                        switch (exif.Orientation) {
                            case 3:
                                degrees = 180;
                                break;
                            case 6:
                                degrees = 90;
                                break;
                            case 8:
                                degrees = -90;
                                break;
                            default:
                                degrees = 0;
                                break;
                        }
                        if (degrees) {
                            var canvas = document.createElement("canvas");
                            canvas.setAttribute("id", "hidden-canvas");
                            canvas.style.display = "none";
                            document.body.appendChild(canvas);

                            var ctx = canvas.getContext("2d");

                            var image = new Image();
                            //assume png if not provided
                            image.src = (e.target.result.indexOf(",") == -1 ? "data:image/png;base64," : "") + e.target.result;
                            image.onload = function() {
                                var w = image.width;
                                var h = image.height;
                                var rads = degrees * Math.PI/180;
                                var c = Math.cos(rads);
                                var s = Math.sin(rads);
                                if (s < 0) { s = -s; }
                                if (c < 0) { c = -c; }
                                //use translated width and height for new canvas
                                canvas.width = h * s + w * c;
                                canvas.height = h * c + w * s;
                                //draw the rect in the center of the newly sized canvas
                                ctx.translate(canvas.width/2, canvas.height/2);
                                ctx.rotate(degrees * Math.PI / 180);
                                ctx.drawImage(image, -image.width/2, -image.height/2);
                                //assume plain base64 if not provided
                                rotatedSrc = canvas.toDataURL();
                                document.body.removeChild(canvas);

                                var $img = createUploadImgCard(rotatedSrc, e.target.result, $form);
                                $imgContainer.append($img);

                                if ($form.data('vehicle-img-single') === true) {
                                    var dataInput = $img.find('.js-vehicle-img-upload__img-data');
                                    dataInput.attr('name', dataInput.attr('name') + '-' + $img.index());
                                }

                                $imgContainer.sortable('refresh');
                            };
                        } else {
                            var $img = createUploadImgCard(e.target.result, e.target.result, $form);
                            $imgContainer.append($img);

                            if ($form.data('vehicle-img-single') === true) {
                                var dataInput = $img.find('.js-vehicle-img-upload__img-identifier');
                                dataInput.val($img.index());
                            }

                            $imgContainer.sortable('refresh');
                        }
                    };

                    dataUrlReader.readAsDataURL(file);
                });

                if(input.files.length > 0) {
                    $form.find('.js-vehicle-img-upload__editing-request').removeClass('disabled');
                }
            });

            $form.on('click', '.js-vehicle-img-upload__delete', function () {
                var $img = $(this).closest('.js-vehicle-img-upload__img');
                if ($img.data('position')) {
                    toDelete.push($img.data('position'));
                    unloadMessage.add();
                }
                $img.remove();

                if($form.find('.js-vehicle-img-upload__img-img').length === 0) {
                    $form.find('.js-vehicle-img-upload__editing-request').addClass('disabled');
                }
            });

            $form.on('change', '.js-vehicle-img-upload__img-pos-select', function (evt) {
                unloadMessage.add();

                if (evt.target.value) {
                    /* update selects with the same value*/
                    var selectToChange = $('.js-vehicle-img-upload__img-pos-select').not(this).filter(function () {
                        return $(this).val() === evt.target.value;
                    });

                    var newValue = getFirstFreeAvailableValue();

                    if (newValue) {
                        selectToChange.val(newValue);
                    } else {
                        selectToChange.val('');
                    }
                }
            });

            $form.find('.js-vehicle-img-upload__editing-request').on('click', function (evt) {
                evt.preventDefault();
                var $input = $($(this).data('target'));

                //set value to 1
                $input.val('1');

                $form.submit();
            });

            $form.on('submit', function (evt) {
                $('.js-vehicle-img-upload__img-pos-select').filter(function () {
                    return !$(this).val();
                }).each(function () {
                    var freeValue = getFirstFreeAvailableValue();
                    if (freeValue) {
                        $(this).val(freeValue)
                    }
                });

                evt.preventDefault();
                unloadMessage.remove();
                $modalError.attr('hidden', 'hidden');
                $modalLoading.attr('hidden', null);
                $modal.modal('show');

                var formData;

                if ($form.data('vehicle-img-single') === true) {
                    formData = new FormData($form[0]);
                    var imageData = [];

                    $form.find('.js-vehicle-img-upload__img').each(function (index, item) {
                        var data = {};

                        $(item).find('input').each(function(index, input){
                            if ($(input).is(':checkbox')) {
                                data[$(input).attr('name')] = $(input).is(':checked') ? $(input).val() : null;
                            } else {
                                data[$(input).attr('name')] = $(input).val();
                            }
                        });
                        $(item).find('select').each(function(index, input) {
                            data[$(input).attr('name')] = $(input).val();
                        });
                        imageData.push(data);

                        // Add uploaded binary to form
                        if ($(item).hasClass('is-not-uploaded')) {
                            var identifier = $(item).find('.js-vehicle-img-upload__img-identifier');
                            formData.append('image' + '-' + identifier.attr('name') + '-' + identifier.val(), dataURItoBlob($(item).data('img')));
                        }
                    });
                    formData.append('imageData', JSON.stringify(imageData));
                } else {
                    formData = new FormData($form[0]);
                    var toMove = [];
                    $form.find('.js-vehicle-img-upload__img-pos-select').filter(function (index, select) {
                        return $(select).val();
                    }).toArray().forEach(function (select) {
                        var $element = $(select).closest('.js-vehicle-img-upload__img');
                        var selectedValue = $(select).val();

                        if ($element.hasClass('is-not-uploaded')) {
                            formData.append(
                                selectedValue,
                                dataURItoBlob($element.data('img'))
                            );
                        } else {
                            var oldPosition = $element.data('position');
                            if (oldPosition !== selectedValue) {
                                toMove.push({
                                    from: oldPosition,
                                    to: selectedValue
                                });
                            }
                        }
                    });
                    formData.append('toMove', JSON.stringify(toMove));
                    formData.append('toDelete', JSON.stringify(toDelete));
                }

                $.ajax($form.attr('action') || location.href , {
                    type: "POST",             // Type of request to be send, called as method
                    data: formData,                   // Data sent to server, a set of key/value pairs (i.e. form fields and values)
                    contentType: false,       // The content type used when sending data to the server.
                    cache: false,             // To unable request pages to be cached
                    processData:false        // To send DOMDocument or non processed data file it is set to false
                }).done(function (data) {
                    $resultContainer.html(data);
                    $modal.modal('hide');
                    window.location.reload();
                }).fail(function (a,b,c) {
                    $modalError.attr('hidden', null);
                    $modalLoading.attr('hidden', 'hidden');
                    console.warn('error uploading images', a, b, c);
                });
            });

            $modalRequest.on('click', function(evt){
                evt.preventDefault();
                evt.stopPropagation();
            });

            $modalRequestError.on('click', function(evt){
                evt.preventDefault();
                evt.stopPropagation();
            });

            $form.on('click', '.js-vehicle-img-upload__request', function (evt) {
                evt.preventDefault();
                evt.stopPropagation();
                var url = $(this).data('action');

                $.ajax(url , {
                    type: "POST",
                    cache: false,
                    dataType: 'json'
                }).done(function (response) {
                    if(response.success === 1) {
                        $modalRequest.modal('show');
                    } else {
                        $modalRequestError.modal('show');
                    }
                }).fail(function (a,b,c) {
                    console.error(a,b,c);
                });
            })
        });
    }

    function getFirstFreeAvailableValue () {
        var $selects = $('.js-vehicle-img-upload__img-pos-select');

        var $options = $selects.eq(0).find('option.js-vehicle-img-upload__unassigned');
        for (var i = 0; i < $options.length; i++) {
            var isUsed = !!$selects.filter(function () {
                return $(this).val() === $options.eq(i).attr('value');
            }).length;

            console.log('is used?', $options.eq(i), isUsed);

            if (!isUsed) {
                return $options.eq(i).attr('value');
            }
        }
    }

    function createUploadImgCard (imgSrc, originalImgSrc, $form) {
        var template = $form.find('.js-vehicle-img-upload__img-template').html();
        var $newElement = $(template);
        $newElement.find('.js-vehicle-img-upload__img-img').css('background-image', 'url(' + imgSrc + ')');
        $newElement.addClass('is-not-uploaded').data('img', originalImgSrc);

        return $newElement;
    }

    var unloadMessage = (function () {
        var isAdded = false;
        function handler (e) {
            var confirmationMessage = 'It looks like you have been editing something. '
                + 'If you leave before saving, your changes will be lost.';

            (e || window.event).returnValue = confirmationMessage; //Gecko + IE
            return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
        }

        return {
            add: function () {
                if (!isAdded) {
                    isAdded = true;
                    window.addEventListener("beforeunload", handler)
                }
            },
            remove: function () {
                isAdded = false;
                window.removeEventListener("beforeunload", handler)
            }
        }
    }());

    function dataURItoBlob(dataURI) {
        // convert base64/URLEncoded data component to raw binary data held in a string
        var byteString;
        if (dataURI.split(',')[0].indexOf('base64') >= 0)
            byteString = atob(dataURI.split(',')[1]);
        else
            byteString = unescape(dataURI.split(',')[1]);

        // separate out the mime component
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to a typed array
        var ia = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        return new Blob([ia], {type:mimeString});
    }

    function base64ToArrayBuffer (base64) {
        base64 = base64.replace(/^data\:([^\;]+)\;base64,/gmi, '');
        var binaryString = atob(base64);
        var len = binaryString.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes.buffer;
    }

    return function ($scope) {
        $.loadScript("/static/js/libs/exif.js").done(function () {
            init($scope);
        });
    };
}());

app.reservationTimeoutModal = function () {
    if (!_config.reservationTimeoutModalUrl) {
        console.warn('Can not init app.reservationTimeoutModal:  _config.reservationTimeoutModalUrl was not set.');
    }

    var $modal = $('.js-reservation-timeout-modal');
    $modal.modal({
        backdrop: 'static',
        keyboard: false,
        show: false
    });

    $('.js-reservation-timeout-modal__extend').on('click', function () {
        window.location = window.location.origin + window.location.pathname + '?extend-expiration';
    });

    var modalIsVisible = false;
    var interval = setInterval(function () {
        $.ajax({
            type: 'GET',
            url: _config.reservationTimeoutModalUrl
        }).done(function (data) {
            if (modalIsVisible) {
                return;
            }

            if(data.expire) {
                var warning = new Date(data.warning);
                var now = new Date();
                if (warning < now) {
                    $modal.modal('show');
                    modalIsVisible = true;
                    clearInterval(interval);
                }
            }
        });
    }, 60000); // 60s
};

app.modules.saveTabState = function ($scope) {
    $scope.find('.js-save-active a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
        window.sessionStorage.setItem('activeTab', $(e.target).attr('href'));
    });

    if(window.sessionStorage.getItem('activeTab')) {
        $('.js-save-active').find('a[href="'+ window.sessionStorage.getItem('activeTab') +'"]').tab('show');
    }
};

app.modules.rangeSelects = function ($scope) {
    $scope.find('.js-range-selects__from').on('change', function () {
        changeHandler($(this));
    }).each(function () {
        changeHandler($(this));
    });

    function changeHandler ($select) {
        var value = +$select.val();
        var $options = $select
            .closest('.js-range-selects')
            .find('.js-range-selects__to > option')
            .not(':first-child');

        $options.each(function () {
            if (+$select.val() < value) {
                $select.attr('disabled', 'disabled');
            } else {
                $select.attr('disabled', null);
            }
        });

        if ($options.filter(':selected:disabled').length) {
            $select.closest('.js-range-selects').find('.js-range-selects__to').val(null);
        }
    }
};

app.modules.rangeSlider = function ($scope) {
    var $sliders = $scope.find('.js-range-slider__slider');

    $sliders.each(function() {
        var $elem = $(this);
        var min = $elem.data("min") - $elem.data("step");
        var max = $elem.data("max") + $elem.data("step");
        var step = $elem.data("step");

        $.loadScript("/static/js/min/070_nouislider.min.js").done(function () {
            var sliderObj = noUiSlider.create($elem[0], {
                start: [min, max],
                step: step,
                connect: [false, true, false],
                range: {
                    'min': [min],
                    'max': [max]
                }
            });
            var userInput = false;

            sliderObj.on('start', function () {
                userInput = true;
            });

            sliderObj.on('change', function (values, handle) {
                var value = parseInt(values[handle]);
                var elem;
                if (handle) {
                    elem = $elem.closest('.js-range-slider').find('.js-range-inputs__to');
                } else {
                    elem = $elem.closest('.js-range-slider').find('.js-range-inputs__from');
                }

                if (userInput) {
                    userInput = false;

                    if (value !== min && value !== max) {
                        elem.val(value).trigger('change');
                    } else {
                        elem.val("").trigger('change');
                    }

                    if (handle && value === max) {
                        var rangeSlider = elem.closest('.js-range-slider').find('.js-range-slider__slider')[0].noUiSlider;
                        rangeSlider.set([null, rangeSlider.options.range.max]);
                    }
                }

                app.tracking.trackTriggerEvent( 'regler', elem.data('layer-action'), elem.val() );

                if($elem.closest('.js-range-slider').closest('.dropdown').length && $elem.closest('.js-range-slider').closest('.dropdown').hasClass('open')) {
                    $elem.closest('.js-range-slider').closest('.dropdown').trigger('dropdown.range.slider.changed', sliderObj);
                }
            });

            sliderObj.on('set', function () {
                if($elem.closest('.js-range-slider').closest('.dropdown').length && $elem.closest('.js-range-slider').closest('.dropdown').hasClass('open')) {
                    $elem.closest('.js-range-slider').closest('.dropdown').trigger('dropdown.range.slider.changed');
                }
            });

            sliderObj.on('update', function (values, handle) {
                var value = parseInt(values[handle]);
                var elem;
                if (handle) {
                    elem = $elem.closest('.js-range-slider').find('.js-range-inputs__to');
                } else {
                    elem = $elem.closest('.js-range-slider').find('.js-range-inputs__from');
                }

                if (userInput) {
                    if (value !== min && value !== max) {
                        elem.val(value);
                    } else {
                        elem.val("");
                    }
                }
            });
        });
    });
};

app.modules.rangeSliderSelect = function ($scope) {
    $scope.find('.js-range-inputs__from').one('change', function (evt) {
        if (!evt.isTrigger && app.cookiePermissions.getServicePermission('gtm')) {
            app.tracking.trackTriggerEvent( 'suchfeld', $(this).data('layer-action'), $(this).val() );
        }
        changeSlider($(this), "from");
    });

    $scope.find('.js-range-inputs__to').one('change', function (evt) {
        if (!evt.isTrigger && app.cookiePermissions.getServicePermission('gtm')) {
            app.tracking.trackTriggerEvent( 'suchfeld', $(this).data('layer-action'), $(this).val() );
        }
        changeSlider($(this), "to");
    });

    function changeSlider ($input, slider) {
        var value = $input.val();
        var rangeSlider = $input.closest('.js-range-slider').find('.js-range-slider__slider')[0].noUiSlider;

        if(slider === "from") {
            rangeSlider.set([value, null]);
        } else {
            if(value) {
                rangeSlider.set([null, value]);
            } else {
                rangeSlider.set([null, rangeSlider.options.range.max]);
            }

        }
    }

};

app.modules.modalLink = function ($scope) {
    $scope.find('.js-modal-link').on('click', function (e) {
        e.preventDefault();
        var $this = $(this);
        var link = $this.attr('href') + "?disable-layout=1";

        var modal = $('#js-modal-link-target');
        var modalBody = modal.find(".modal-body");

        $.ajax(link, {
            beforeSend: function () {
                modalBody.empty();
            },
            success: function (html) {
                html = $(html).find('#mainContent');
                html.find('a:not([data-toggle="collapse"])').removeAttr('href');
                modalBody.html(html);

                modal.find('.spinner-overlay').addClass('hidden');
            }
        });
        modal.modal('show').find('.spinner-overlay').removeClass('hidden');
    });
};

app.modules.dataLayer = function ($scope) {
    $scope.find('.js-datalayer').on('click', function (evt) {
        var category = $(this).data('layer-category'),
            action = $(this).data('layer-action'),
            $target = $(evt.target),
            label = $target.data('layer-label');

        if(!$target.data('layer-label')) {
            var closestLabel = $target.closest('[data-layer-label]');

            if(closestLabel.length > 0) {
                label = $(closestLabel).data('layer-label');
            } else {
                label = $target[0]
            }
        }

        app.tracking.trackTriggerEvent( category, action, label );
    });

    $scope.find('.js-change-datalayer').on('change', function () {
        var $target = $($(this).data('target')),
            action = $(this).data('layer-action');

        if (action) {
            $target.data('layer-action', action + ' ' + $(this).find('option:selected').data('value'));
        }
    });
};

app.modules.copyInputValue = function ($scope) {
    $scope.find('.js-copy-input-value').each(function (index, ele) {
        var $input = $(ele).find('input, select');
        var inputId = $(ele).data('input-target-id');
        $('[id="' + inputId + '"]').on('input', function () {
            $input.val($(this).val());
        });
    });
};

app.ping = function () {
    setInterval(function () {
        $.ajax(location.origin + '/login', {
            headers: {Ajax: 1},
            cache: false
        });
    }, 1000 * 60);
};

app.modules.trackForm = function () {
    $('.js-track-form').on('submit', function (evt) {
        var $form = $(this);
        var events = [];

        $form.find(':input').each(function () {
            var $input = $(this);

            if (!$input.val()
                || $input.is('[type=checkbox]:not(:checked),[type=radio]:not(:checked)')
                || $input.attr('name') === 'clear'
            ) {
                return;
            }

            events.push({
                'action': $input.data('action') || $input.attr('name'),
                'label': $input.data('label') || $input.val()
            });
        });

        events.forEach(function (event) {
            app.tracking.trackTriggerEvent( $form.data('category'), event.action,event.label );
        });
    })
};

app.modules.chatWidget = function ($scope) {
    $scope.find('.js-toggle-chat').on('click', function (evt) {
        evt.preventDefault();
        var $box = $($(this).data('target'));

        if(!$box.hasClass('is-active')) {
            $box.addClass('is-active');

            $('body').on('click', bodyClickHandler);
        } else {
            $box.removeClass('is-active');
            $('body').off('click', bodyClickHandler);
        }
    });

    function bodyClickHandler (evt) {
        if ($(evt.target).parents('.chat-widget').length < 1 && $(evt.target).parents('.js-toggle-chat').length < 1 && !$(evt.target).hasClass('js-toggle-chat')) {
            evt.preventDefault();
            $('.chat-widget').removeClass('is-active');
            $('body').off('click', bodyClickHandler);
        }
    }
};

app.modules.countdown = function ($scope) {
    var countdown = $scope.find('.js-countdown'),
        date = countdown.data('countdown');

    var t = setInterval(function() {
        var actualTime = new Date().getTime(),
            time = date - actualTime;

        var hours = Math.floor((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((time % (1000 * 60)) / 1000);

        hours = hours < 10 ? '0' + hours : hours;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        seconds = seconds < 10 ? '0' + seconds : seconds;

        if (time < 0) {
            clearInterval(t);
        } else {
            countdown.text(hours + ':' + minutes + ':' + seconds);
        }
    }, 1000);
};

app.modules.submitOnChange = function ($scope) {
    $scope.find('.js-submit-on-change').on('change', function () {
        $(this).closest('form').submit();
    });
};

app.modules.toggleSearchAgent = function($scope) {
    $scope.find('.js-toggle-searchagent').on('click', function (evt) {
        evt.preventDefault();

        var $this = $(this);
        var $target = $($this.data('target'));


        if(!$target.hasClass('is-open')) {
            $target.addClass('is-open');
            $this.closest('.console__item').addClass('is-open');
        } else {
            $target.removeClass('is-open');
            $this.closest('.console__item').removeClass('is-open');

            window.sessionStorage.setItem('hideSearchAgent', true);
        }
    });

    var $searchAgent = $scope.find('.js-search-agent-overlay');

    if (window.sessionStorage.getItem('hideSearchAgent')) {
        return;
    }

    var timeout = setTimeout(function () {
        $searchAgent.addClass('is-open');
        $searchAgent.closest('.console__item').addClass('is-open');

        clearTimeout(timeout);
    }, $searchAgent.data('timeout') || 30000);
};

app.modules.multiForm = function($scope) {
    var $forms = $scope.find('.js-multi-form');

    $('.js-multi-form--submit').on('click', function (evt) {
        evt.preventDefault();
        var $this = $(this);
        var isValid = true;
        var formData = new FormData();

        $forms.each(function () {
            if($(this).parsley().validate() !== true){
                isValid = false;
            }
        });

        $.each($forms.serializeArray(), function (index,input) {
            formData.append(input.name, input.value);
        });

        // add files to formData
        var fileUploads = $forms.find('input[type=file]');
        if(fileUploads && fileUploads[0].files.length) {
            if (window.File && window.FileReader && window.FileList && window.Blob) {
                var files = fileUploads[0].files;
                for(var i = 0; i < files.length; i++) {
                    resizeAndUpload(files[i]);
                }
            } else {
                console.log('The File APIs are not fully supported in this browser.');
            }

            function resizeAndUpload(file) {
                var reader = new FileReader();
                reader.onloadend = function() {

                    var tempImg = new Image();
                    tempImg.src = reader.result;
                    tempImg.onload = function() {
                        var MAX_WIDTH = 400;
                        var MAX_HEIGHT = 300;
                        var tempW = tempImg.width;
                        var tempH = tempImg.height;
                        if (tempW > tempH) {
                            if (tempW > MAX_WIDTH) {
                                tempH *= MAX_WIDTH / tempW;
                                tempW = MAX_WIDTH;
                            }
                        } else {
                            if (tempH > MAX_HEIGHT) {
                                tempW *= MAX_HEIGHT / tempH;
                                tempH = MAX_HEIGHT;
                            }
                        }

                        var canvas = document.createElement('canvas');
                        canvas.width = tempW;
                        canvas.height = tempH;
                        var ctx = canvas.getContext("2d");
                        ctx.drawImage(this, 0, 0, tempW, tempH);
                        var dataURL = canvas.toDataURL("image/jpeg");

                        var fieldName = fileUploads.attr('name');
                        formData.append(fieldName+'[]', dataURL);


                        submitForms();
                    }

                };
                reader.readAsDataURL(file);
            }
        } else {
            submitForms();
        }

        function submitForms() {
            if(isValid) {
                $forms.addClass('is-loading-success');

                $.ajax($this.data('action'), {
                    type: 'POST',
                    data: formData,
                    cache: false,
                    contentType : false,
                    processData : false,
                    timeout: 0,
                    beforeSend: function (jqXHR, settings) {
                        $this.attr('disabled', 'disabled');
                    },
                    complete: function (jqXHR, status) {
                        $this.attr('disabled', false);
                    }
                }).done(function (data) {
                    if(data.success === true) {
                        $('body').append(data.html);
                        var t = setTimeout(function () {
                            $('body').addClass('is-success');
                            clearTimeout(t);
                        }, 10);
                    } else {
                        $forms.removeClass('is-loading-success');
                        $(data.html).insertAfter($this);
                    }
                }).fail(function (a,b,c) {
                    console.error(a,b,c);
                });
            }
        }

    });
};

app.modules.modelSlider = function($scope) {
    var $slider = $scope.find('.js-model-slider'),
        $detail = $slider.find('.js-model-slider__item');

    $detail.on('click', function (evt) {
        var $this = $(this),
            $target = $($(this).data('target'));

        if(!$(this).hasClass('is-active')) {
            // $detail.each(function () {
            //     var $target = $($(this).data('target'));
            //     $(this).removeClass('is-active');
            //     $target.collapse('hide');
            //     $target.find('input, select, .form-control').attr('data-parsley-excluded', true).prop('disabled', true);
            //     $(this).find('.js-model-slider__item__checkbox').prop('checked', false);
            // });

            $(this).find('.js-model-slider__item__checkbox').prop('checked', true);
            $(this).addClass('is-active');

            var pos = $this.offset().left,
                $container = $this.closest('.js-model-slider'),
                containerScroll = $container.scrollLeft(),
                containerPadding = matchMedia('(max-width: 767px)').matches ? 16 : 32,
                offset;

            if($container.outerWidth() < pos + $this.outerWidth()) {
                offset = pos + containerScroll - $container.outerWidth() + $this.outerWidth() + 16;
            } else if($container.offset().left > pos) {
                offset = containerScroll - $container.offset().left + pos - containerPadding;
            }

            $container.animate({ scrollLeft: offset }, 250);


            $target.collapse('show');
            $target.find('input, select, .form-control').attr('data-parsley-excluded', false).prop('disabled', false);
        } else {
            if(!$(evt.target).parents('.collapse-model-teaser').length){
                $(this).removeClass('is-active');
                $target.collapse('hide');
                $target.find('input, select, .form-control').attr('data-parsley-excluded', true).prop('disabled', true);
                $(this).find('.js-model-slider__item__checkbox').prop('checked', false);
            }
        }
    });
};

app.signaturePad = function () {
    var $signature = $('.js-signature'),
        $input = $signature.find('.js-signature__input'),
        $pad = $signature.find('.js-signature__pad')[0],
        $clearButton = $signature.find('.js-signature__clear');

    $.loadScript('/static/build/js/libs/signature_pad.min.js').done(function(){
        // Adjust canvas coordinate space taking into account pixel ratio,
        // to make it look crisp on mobile devices.
        // This also causes canvas to be cleared.
        function resizeCanvas() {
            // When zoomed out to less than 100%, for some very strange reason,
            // some browsers report devicePixelRatio as less than 1
            // and only part of the canvas is cleared then.
            var ratio =  Math.max(window.devicePixelRatio || 1, 1);
            $pad.width = $pad.offsetWidth * ratio;
            $pad.height = $pad.offsetHeight * ratio;
            $pad.getContext("2d").scale(ratio, ratio);
        }

        // window.onresize = resizeCanvas;
        resizeCanvas();

        var signaturePad = new SignaturePad($pad, {
            onEnd: function () {
                var data = signaturePad.toDataURL(('image/png'));
                $input.val(data).parsley().validate();
            }
        });

        $clearButton.on('click', function (evt) {
            evt.preventDefault();

            signaturePad.clear();
            $input.val('');
        });
    });
};

app.modules.uploadImg = function($scope) {
    $scope.find('.js-img-upload').on('change', function(){
        var $container = $(this).closest('.js-img-upload-container');
        var $inputs = $($(this).data('disable-inputs'));

        if($(this)[0].files.length > 0) {
            $container.addClass('has-file');
            $inputs.attr('disabled', true);
            $inputs.attr('data-parsley-excluded', true);
            $inputs.closest('.has-error').removeClass('has-error').find('.form-errors').empty();
        } else {
            $container.removeClass('has-file');
            $inputs.attr('disabled', false);
            $inputs.attr('data-parsley-excluded', false);
        }


        $container.find('.js-img-upload-reset').on('click', function (evt) {
            evt.preventDefault();

            $container.find('.js-img-upload').val('').trigger('change');
        });
    });
};

app.modules.affixHeader = function ($scope) {
    $scope.find('.js-affix-header').each(function () {
        var $this = $(this);
        var $placeholder = $(this).closest('.js-affix-header-placeholder');

        if (!$placeholder || !$placeholder.length) {
            console.error('Affix element', $this, 'is missing a placeholder wrapper(".js-affix-header-placeholder")');
            return;
        }

        if($this.hasClass('js-affix-header--has-placeholder')) {
            $(window).one('scroll', function () {
                $placeholder.css('height', $this.outerHeight());
            });
        }

        $this.affix({
            offset: {
                top: function () {
                    return $placeholder.offset().top;
                }
            }
        });
    });
};

app.modules.toggleOverlay = function ($scope) {
    $scope.find('.js-toggle-overlay').on('click', function (evt) {
        evt.preventDefault();

        var $this = $(this);
        var $target = $($this.data('target'));

        if(!$target.hasClass('is-open')) {
            $target.addClass('is-open');
        } else {
            $target.removeClass('is-open');
        }
    });
};

app.pwa = function() {
    //fix android keyboard problems
    $('.page-wrapper').css('min-height', $(window).innerHeight());

    // Register the service worker
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('/service-worker-onlinecard.js').then(function(registration) {
            // Registration was successful
            console.log('ServiceWorker registration successful with scope: ', registration.scope);
        }).catch(function(err) {
            // registration failed :(
            console.log('ServiceWorker registration failed: ', err);
        });
    }
};

app.modules.mergeForms = function($scope) {
    $scope.find('.js-merge-form__submit').on('click', function (evt) {
        evt.preventDefault();

        var $form = $(this).closest('.js-merge-form'),
            $target = $($form.data('merge-form'));

        $form.find('.js-merge-form__input').remove();

        $.each($target.serializeArray(), function ( i, input ) {
            $('<input type="hidden" class="js-merge-form__input">').prop(input).appendTo($form);
        });

        $form.submit();
    });
};

app.modules.hotspot = function($scope) {
    var $hotspots = $scope.find('.js-hotspot');

    $hotspots.on('click', function () {
        var $this = $(this),
            $target = $($(this).data('target'));

        if(!$this.hasClass('is-open')) {
            $hotspots.each(function () {
                $(this).removeClass('is-open');
                $($(this).data('target')).removeClass('is-open');
            });

            $this.addClass('is-open');
            $target.addClass('is-open');

            // $('body').on('click', bodyClickHandler);
        } else {
            $this.removeClass('is-open');

            // $('body').off('click', bodyClickHandler);
        }
    });

    $('.js-hotspot--detail__close').on('click', function (evt) {
        evt.preventDefault();
        $hotspots.each(function () {
            $(this).removeClass('is-open');
            $($(this).data('target')).removeClass('is-open');
        });
        // $('body').off('click', bodyClickHandler);
    });

    // function bodyClickHandler (evt) {
    //     if ($(evt.target).parents('.js-hotspot').length < 1 && $(evt.target).parents('.js-hotspot--detail').length < 1 && !$(evt.target).hasClass('js-hotspot--detail')) {
    //         evt.preventDefault();
    //         $('.js-hotspot').removeClass('is-open');
    //         $('.js-hotspot--detail').removeClass('is-open');
    //
    //         $('body').off('click', bodyClickHandler);
    //     }
    // }
};

app.modules.stepForm = function ($scope) {
    var $forms = $scope.find('.js-step-form');

    $forms.each(function () {
        var $form = $(this),
            $steps = $form.find('.js-step-form__step'),
            totalCount = $steps.length - 1,
            $navItems = $form.find('.js-step-form__nav__item');

        $steps.each(function (index) {
            $(this).find(':input').attr('data-parsley-group', 'block-' + index);
        });
        navigateTo(0, $steps, $navItems, $form); // Start at the beginning

        $form.on('submit', function (evt) {
            if(curIndex($form) !== totalCount) {
                evt.preventDefault();
                evt.stopImmediatePropagation();

                $form.parsley().whenValidate({
                    group: 'block-' + curIndex($form)
                }).done(function() {
                    navigateTo(curIndex($form) + 1, $steps, $navItems, $form);
                });
            }
        });

        $navItems.on('click', function(evt) {
            evt.preventDefault();
            var $this = $(this);

            if(curIndex($form) > $(this).data('index')) {
                navigateTo($(this).data('index'), $steps, $navItems, $form);
            } else {
                $form.parsley().whenValidate({
                    group: 'block-' + $this.data('index') - 1
                }).done(function() {
                    navigateTo($this.data('index'), $steps, $navItems, $form);
                });
            }
        });
    });



    function curIndex($form) {
        return $form.find('.js-step-form__step').index($form.find('.js-step-form__step').filter('.is-current'));
    }

    function navigateTo(index, $steps, $navItems, $form) {
        $steps.removeClass('is-current').eq(index).addClass('is-current');
        $navItems.removeClass('is-current').eq(index).addClass('is-current');

        if (app.affixNavBar) {
            app.affixNavBar.disable();
        }

        if($(window).scrollTop() > $form.offset().top) {
            $('html, body').stop().animate({
                    scrollTop: $form.offset().top - 30
                },
                250,
                'swing', function () {
                    if (app.affixNavBar) {
                        app.affixNavBar.enable();
                    }
                }
            );
        }
    }
};

app.modules.leasingForm = function($scope) {
    $scope.find('.js-leasing-form__submit').on('click', function (evt) {
        evt.preventDefault();
        var $form = $(this).closest('.js-leasing-form').find('form');

        var monthlyRate = $form.find('#calculatorMonthlyRateView').text().replace('.', '').replace (',', '.').replace(' €', '');
        var residualValue = $form.find('#residualValueText').text().replace('.', '').replace(' €', '').replace(',', '.');

        window.open($(this).data('action') + $form.serialize() + '&monthlyRate=' + monthlyRate + '&residualValue=' + residualValue, '_self');
    });
};

app.modules.loadLeasingIFrame = function() {
    var buttons = document.querySelectorAll('.js-load-leasing__btn');
    var iframe = document.querySelector('.js-load-leasing__widget');
    var loading = document.querySelector('.js-load-leasing__loading');
    var isLoading = false;

    if (buttons) {
        buttons.forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                var pendingRequest;
                var url = "/car/leasing-process/"+btn.getAttribute("data-car");

                if(iframe.getAttribute("src") === null) {

                    loading.removeAttribute("hidden")

                    if (pendingRequest) {
                        pendingRequest.abort();
                    }

                    pendingRequest = $.ajax(url, {
                        cache: true,
                        dataType: 'json'
                    }).done(function (res) {
                        if (res.success) {

                            window.addEventListener('message', function (msg) {
                                if (typeof msg.data === 'object' && msg.data.type === 'widgetHeightResize') {
                                    if (msg.data.payload.height > 0) {
                                        iframe.style.height = msg.data.payload.height + 'px';
                                    }
                                    if (isLoading) {
                                        isLoading = false;
                                        loading.setAttribute("hidden", true);
                                    }
                                }

                                if (typeof msg.data === 'object' && msg.data.type === 'doneLoading') {
                                    iframe.contentWindow.postMessage({type: "ocapiData", payload: res.vehicleData}, '*');
                                    isLoading = true;
                                }
                            }, false);

                            iframe.addEventListener('load', function () {
                                iframe.contentWindow.postMessage('getHeight', 'https://test.widget.mbfsa.at');
                            });

                            iframe.setAttribute("src", res.url);
                        }
                    }).always(function () {
                        pendingRequest = null;
                    });
                }
            })
        });

        //check if leasing tab opened from grid
        const currentUrl = window.location.href;

        if (currentUrl.includes("&showLeasingTab=1")) {
            buttons[0].click();
        }
    }
};

app.modules.quickFilter = function($scope) {
    function renderItem(filter, renderInputs) {
        var text;

        if (filter.isCheckboxFilter) {
            text = filter.label;
        } else {
            text = filter.label ? filter.label + ': ' + filter.value : filter.value;
        }

        if (renderInputs) {
            return text;
        } else {
            return '<button type="button" class="filter-button filter-button--lg"><span class="filter-button__icon icon icon-close"></span>' + text + '</button>';
        }
    }

    function render($quickFilterBar, inputs, renderInputs) {
        var $form = $($quickFilterBar.data('target'));
        var tags = [];

        $quickFilterBar.empty();

        $.each(inputs, function (index, filter) {
            if (renderInputs) {
                tags.push(renderItem(filter, renderInputs));
                return;
            }

            var $newItem;
            $newItem = $(renderItem(filter, renderInputs));
            $quickFilterBar.append($newItem);

            if ($newItem) {
                $newItem.on('click', function () {
                    if (filter.isCheckboxFilter) {
                        $form.find('[name="'+ filter.name +'"][value="'+ filter.value +'"]').prop('checked', false);
                    } else {
                        $form.find('[name="'+ filter.name +'"]').val('0');
                    }

                    $form.submit();
                });
            }
        });

        if (tags.length > 0) {
            $quickFilterBar.append($('<input type="hidden" name="searchAgentTags" />').val(tags.join('; ')));
        }

        if (inputs.length > 0) {
            $quickFilterBar.closest('.js-quickfilter-container').removeClass('hidden');
        }


        app.modules.expandable($scope);
    }


    $scope.find('.js-quickfilter').each(function (index, quickFilterBar) {
        var $quickFilterBar = $(quickFilterBar),
            $form = $($quickFilterBar.data('target'));

        var inputs = [], param;
        if (window.location.search.length > 0)  {
            var params = decodeURIComponent(window.location.href.replace(/\+/g, ' ')).slice(window.location.href.indexOf('?') + 1).split('&');

            if (params) {
                for(var i = 0; i < params.length; i++) {
                    param = params[i].split('=');
                    const $formField = $form.find('[name="' + param[0] + '"]');
                    if ($formField.length && !$formField.hasClass('js-quickfilter-input--hidden')) {
                        if (param[1] !== '0' && param[1].length > 0) {

                            if ($form.find('[value="' + param[1] + '"][name="' + param[0] + '"]').is(':checkbox')) {
                                if ($form.find('[value="' + param[1] + '"][name="' + param[0] + '"]').data('sr-only') !== 1) {
                                    inputs.push({
                                        name: param[0],
                                        value: param[1],
                                        label: $form.find('[value="' + param[1] + '"][name="' + param[0] + '"]').data('label'),
                                        isCheckboxFilter: $form.find('[value="' + param[1] + '"][name="' + param[0] + '"]').is(':checkbox')
                                    })
                                }
                            } else {
                                inputs.push({
                                    name: param[0],
                                    value: param[1],
                                    label: $form.find('[name="'+ param[0] +'"]').data('label'),
                                    isCheckboxFilter: false
                                })
                            }
                        }
                    }
                }
                render($quickFilterBar, inputs, !!$quickFilterBar.data('hidden-inputs'));
            }
        }
    });

};

app.modules.expandable = function($scope) {
    function initCollapseElement($expandableElement) {
        var expandableContent = $expandableElement.find('.js-expandable__content-wrapper');

        if (expandableContent[0].scrollHeight > expandableContent.outerHeight()) {
            $expandableElement.removeClass('is-not-expandable');
            $expandableElement.addClass('is-expandable is-collapsed');

            $expandableElement.find('.js-expandable__more').on('click', function (evt) {
                evt.preventDefault();
                $expandableElement.removeClass('is-collapsed');
            }).on('click', function (evt) {
                evt.preventDefault();
            });
        } else if (expandableContent[0].scrollHeight != 0) { // if display none
            $expandableElement.addClass('is-not-expandable').removeClass('is-collapsed');
        }
    }

    $(window).on('load', function () {
        $scope.find('.js-expandable').each(function () {
            var $expandableElement = $(this);

            var $tabParent = $expandableElement.closest('.tab-pane');
            if ($tabParent && $tabParent.length && !$tabParent.hasClass('active')) {
                var id = $tabParent.attr('id');
                var $tabTrigger = $('[data-toggle="tab"][href="#' + id + '"], [data-toggle="tab"][data-target="#' + id + '"]');

                $tabTrigger.on('shown.bs.tab', function () {
                    initCollapseElement($expandableElement)
                });

                return;
            }

            initCollapseElement($expandableElement);
        });
    });


};

app.modules.lazyImg = (function () {
    function getPrefixedDataSet(prefix, $domNode) {
        prefix = lowerCaseFirstLetter(prefix.split('-').map(upperCaseFirstLetter).join(''));

        return Object.keys($domNode.data() || {})
            .filter(function (arr) {
                return arr[0].indexOf(prefix) === 0;
            })
            .map(function (arr) {
                var key = arr[0];
                var value = arr[1];
                return ([lowerCaseFirstLetter(key.replace(prefix, '')), value]);
            })
            .reduce(function (acc, arr) {
                var key = arr[0];
                var value = arr[1];

                acc = $.extend({}, acc);
                acc[key] = value;
                return acc;
            }, {});
    }
    function lowerCaseFirstLetter(string) {
        return string.charAt(0).toLowerCase() + string.slice(1);
    }
    function upperCaseFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    function switchImage($img, addLazyLoading) {
        if ($img.is('picture')) {
            $img.find('source, img').each(function () {
                if (addLazyLoading) {
                    $img.find('img').attr('loading', 'lazy')
                }
                if ($(this).data('srcset')) {
                    $(this).attr('srcset', $(this).data('srcset'));
                }

                if ($(this).data('src')) {
                    $(this).attr('src', $(this).data('src'));
                }
            });
        } else {
            if (addLazyLoading) {
                $img.attr('loading', 'lazy');
            }

            if ($img.data('srcset')) {
                $img.attr('srcset', $img.data('srcset'));
            }

            if ($img.data('src')) {
                $img.attr('src', $img.data('src'));
            }
        }
    }


    var defaultSelectors = {
        base: '.js-lazy-img',
        backgroundModifier: '.js-lazy-img--bg'
    };

    var defaultOptions = {
        offset: window.innerHeight / 2,
        preventNative: false
    };

    return createInitInScope();

    function createInitInScope(selectors, options) {
        selectors = selectors || defaultSelectors;
        options = options || defaultOptions;

        return function ($scope) {
            var $images = [];
            $scope.find(selectors.base).each(function (index, item) {
                $images.push($(item).closest('picture').length > 0 ? $(item).closest('picture') : $(item));
            });

            if ('loading' in HTMLImageElement.prototype && !options.preventNative) {
                $.each($images, function (index, el) {
                    var $image = $(el);

                    if ($image.is(selectors.backgroundModifier)) {
                        onEnterViewPort($image, function (img) {
                            loadImg($(img), selectors, options);
                        }, options);
                    } else {
                        switchImage($image, true)
                    }

                });
            } else {
                $.each($images, function (index, el) {
                    var $image = $(el);

                    var elementOptions = $.extend({}, options, getPrefixedDataSet('lazy-img', $image));

                    onEnterViewPort($image, function (img) {
                        loadImg($(img), selectors, elementOptions);
                    }, elementOptions);
                });
            };

            return $images;

        };
    }

    function loadImg($img, selectors) {
        selectors = selectors || {};
        selectors = $.extend({}, defaultSelectors, selectors);

        if ($img.is(selectors.backgroundModifier)) {
            // background image
            var url = getPrefixedDataSet('lazy-img', $img).background;
            if (url) {
                $img.css('background-image', 'url(' + url + ')');
            }
        } else {
            // usual image
            switchImage($img, false);

            if (!window.HTMLPictureElement) {
                picturefill({
                    reevaluate: true
                });
            }
        }
    }

}());

app.modules.lazyIframe = (function () {
    function getPrefixedDataSet(prefix, $domNode) {
        prefix = lowerCaseFirstLetter(prefix.split('-').map(upperCaseFirstLetter).join(''));

        return Object.keys($domNode.data() || {})
            .filter(function (arr) {
                return arr[0].indexOf(prefix) === 0;
            })
            .map(function (arr) {
                var key = arr[0];
                var value = arr[1];
                return ([lowerCaseFirstLetter(key.replace(prefix, '')), value]);
            })
            .reduce(function (acc, arr) {
                var key = arr[0];
                var value = arr[1];

                acc = $.extend({}, acc);
                acc[key] = value;
                return acc;
            }, {});
    }
    function lowerCaseFirstLetter(string) {
        return string.charAt(0).toLowerCase() + string.slice(1);
    }
    function upperCaseFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    var defaultSelectors = {
        base: '.js-lazy-iframe'
    };

    var defaultOptions = {
        offset: window.innerHeight / 2,
        preventNative: false
    };

    return createInitInScope();

    function createInitInScope(selectors, options) {
        selectors = selectors || defaultSelectors;
        options = options || defaultOptions;

        return function ($scope) {
            var $iframes = $scope.find(selectors.base);

            $iframes.each(function (index, el) {
                const $iframe = $(el);

                var elementOptions = $.extend({}, options, getPrefixedDataSet('lazy-iframe', $iframe));

                onEnterViewPort($iframe, function (iframe) {
                    console.log('iframe enter viewport');
                    switchIframe($iframe);
                }, elementOptions);
            });

            return $iframes;

        };
    }

    function switchIframe($iframe, addLazyLoading) {
        if(addLazyLoading){
            $iframe.attr('loading', 'lazy');
        }

        if ($iframe.data('src')) {
            $iframe.attr('src', $iframe.data('src'));
        }
    }
}());


var onEnterViewPort = (function () {
    var subscriptions = [];
    var impressionInterval;
    var defaultSettings = {
        offset: 0
    };
    function onEnterViewPort ($newElements, callback, settings) {
        $newElements.each(function (index) {
            subscriptions.push({
                $element: $newElements.eq(index),
                callback: callback,
                settings: $.extend({}, defaultSettings, settings)
            });
        });

        if(!impressionInterval) {
            impressionInterval = setInterval(function () {
                subscriptions = subscriptions.filter(function (subscription) {
                    return isElementInDom(subscription.$element);
                });

                var inViewport = subscriptions.filter(function (subscription) {
                    return isElementInViewport(subscription.$element, subscription.settings.offset);
                });

                subscriptions = subscriptions.filter(function (subscription) {
                    return !isElementInViewport(subscription.$element, subscription.settings.offset);
                });

                inViewport.forEach(function (subscription) {
                    subscription.callback.call(subscription.$element, subscription.$element);
                });

                if (subscriptions.length === 0) {
                    clearInterval(impressionInterval);
                    impressionInterval = null;
                }
            }, 200);
        }
    }

    function isElementInViewport (el, offset) {
        offset = offset || 0;
        if (typeof jQuery === "function" && el instanceof jQuery) {
            el = el[0];
        }

        var rect = el.getBoundingClientRect();

        if (!isElementVisible(el) ) {
            return false;
        }

        return (
            rect.top + offset >= 0 &&
            rect.left >= 0 &&
            rect.bottom - offset <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
            rect.left <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
        );
    }

    function isElementVisible(el) {
        if (typeof jQuery === "function" && el instanceof jQuery) {
            el = el[0];
        }

        var rect = el.getBoundingClientRect();

        return !(rect.top === 0 &&
            rect.bottom === 0 &&
            rect.height === 0 &&
            rect.width === 0
        );
    }

    function isElementInDom(el) {
        if (typeof jQuery === "function" && el instanceof jQuery) {
            el = el[0];
        }

        return document.body.contains(el);
    }

    return onEnterViewPort;
}());

app.modules.modelTeaser = function($scope) {
    if (matchMedia('(hover: none)').matches && matchMedia('(pointer:coarse)').matches) {
        var teaser = $scope.find('.js-model-teaser');

        teaser.each(function (index, item) {
            $(item).on('click', function (evt) {
                if ($(this).hasClass('is-active')) {
                    $(this).removeClass('is-active');
                    $('body').off('click', bodyClickHandler);
                } else {
                    teaser.removeClass('is-active');
                    $(this).addClass('is-active');

                    $('body').on('click', bodyClickHandler);
                }
            });
        });

        function bodyClickHandler (evt) {
            if ($(evt.target).parents('.js-model-teaser').length < 1) {
                evt.preventDefault();
                console.log('bodylcikc')
                $('.js-model-teaser').removeClass('is-active');
                $('body').off('click', bodyClickHandler);
            }
        }
    }
};

app.modules.threesixtyInterior = function ($scope) {
    $.loadScript('/static/js/libs/pannellum.js').done(function() {
        var viewer,
            images = _config.threesixtyInteriorUrl || [];

        if (images.length === 1) {
            viewer = pannellum.viewer('panorama', {
                "type": "equirectangular",
                "panorama": images[0],
                "autoLoad": true,
                "showControls": false
            });
        } else if( images.length > 0 ) {
            viewer = pannellum.viewer('panorama', {
                "type": "cubemap",
                "cubeMap": images,
                "autoLoad": true,
                "showControls": false,
                'backgroundColor': [255,255,255]
            });
        }

        $scope.find('.js-threesixty__slider-zoom').on('click', function () {
            var zoom = viewer.getHfov();

            if ($(this).data('direction') === 'out') {
                zoom = viewer.getHfov() + 10;
            } else {
                zoom = viewer.getHfov() - 10;
            }

            viewer.setHfov(zoom);
        });
    });

    $scope.find('.js-threesixty-interior').each(function () {
        var $this = $(this);
        if ($this.closest('.tab-pane.active').length) {
            $this.find('.js-threesixty-interior__iframe').attr('src', $this.find('.js-threesixty-interior__iframe').data('src'));
        }
    });

    $scope.find('.js-threesixty-interior__change').on('click', function () {
        var src = $(this).data('src');

        $(this).closest('.js-threesixty-interior').find('.js-threesixty-interior__change').each(function () {
            $(this).removeClass('is-active');
        });

        $(this).addClass('is-active');

        $(this).closest('.js-threesixty-interior').find('.js-threesixty-interior__iframe').attr('src', src);
    });

    var iframe = $scope.find('.js-threesixty-interior__iframe');
    var $tabPaneParent = iframe.closest('.tab-pane');
    var $tabTrigger = $('[href="#' + $tabPaneParent.attr('id') + '"],[data-toggle=tab][data-target="#' + $tabPaneParent.attr('id') + '"]');
    $tabTrigger.one('shown.bs.tab', function () {
        iframe.attr('src', iframe.data('src'))
    });
}

app.modules.threesixty = function($scope) {
    function threesixty (container, images, options) {
        const defaults = {
            interactive: true,
            reverse: true,
            currentFrame: 0
        }

        const o = Object.assign({}, defaults, options)
        const totalFrames = images.length

        var mouseX = 0
        var oldMouseX = 0

        preloadimages(images, start)

        function preloadimages (sourceImages, cb) {
            const total = sourceImages.length
            var loaded = 0

            function onload () {
                if (++loaded >= total) cb(finalImages)
            }

            const finalImages = sourceImages.map(function (item) {
                const image = new Image()
                image.src = item
                image.onload = onload
                image.onerror = onload
                image.onabort = onload
                image.draggable = false
                return image
            })
        }

        function start (loadedImages) {
            images = loadedImages

            emptyDomNode(container)
            container.appendChild(images[o.currentFrame])

            if (o.interactive) {
                initListeners()
            }
        }

        function initListeners () {
            container.addEventListener('touchstart', startDrag, {passive: true})
            container.addEventListener('mousedown', startDrag)
        }

        function drag (e) {
            if (!isTouchEvent(e)) {
                e.preventDefault()
            }

            mouseX = (e.pageX !== undefined) ? e.pageX : e.changedTouches[0].pageX

            if (Math.abs(mouseX - oldMouseX) < 6) {
                return
            }

            if (o.reverse) {
                if (mouseX > oldMouseX) {
                    previous()
                } else if (mouseX < oldMouseX) {
                    next()
                }
            } else {
                if (mouseX < oldMouseX) {
                    console.log('prev')
                    previous()
                } else if (mouseX > oldMouseX) {
                    console.log('next')
                    next()
                }
            }

            oldMouseX = mouseX
        }

        function startDrag (e) {
            if (!isTouchEvent(e)) {
                e.preventDefault()
            }

            document.addEventListener('touchmove', drag, {passive: true})
            document.addEventListener('mousemove', drag)
            document.addEventListener('touchend', stopDrag)
            document.addEventListener('mouseup', stopDrag)
        }

        function stopDrag (e) {
            if (!isTouchEvent(e)) {
                e.preventDefault()
            }

            document.removeEventListener('touchmove', drag)
            document.removeEventListener('mousemove', drag)
            document.addEventListener('touchend', stopDrag, {passive: true})
            document.addEventListener('mouseup', stopDrag)
        }

        function replaceImage () {
            container.replaceChild(images[o.currentFrame], container.childNodes[0])
        }

        function previous (){
            o.currentFrame--
            if (o.currentFrame < 0) o.currentFrame = totalFrames - 1
            replaceImage()
        }

        function next() {
            o.currentFrame++
            if (o.currentFrame === totalFrames) o.currentFrame = 0
            replaceImage()
        }
    }

    function emptyDomNode(element) {
        if (element.hasChildNodes()) {
            while (element.firstChild) {
                element.removeChild(element.firstChild)
            }
        }
    }

    function isTouchEvent (e) {
        return e.touches
    }

    var $container = $scope.find('.js-threesixty'),
        $slider = $container.find('.js-threesixty__slider'),
        $loading = $container.find('.js-threesixty__loading');

    $loading.removeAttr('hidden');

    $.ajax($container.data('url'), {
        cache: true,
        dataType : 'json'
    }).done(function (response) {
        if (response.success) {
            var slider = threesixty($slider[0], response.data);

            $slider.append('<img src='+ response.data[0] +'>');
        }

        $loading.attr('hidden', true);
    }).fail(function (response,errorType,errorText) {
        console.error('threesixty error', + response,errorType,errorText)
    });

};

app.modules.imageZoom = function ($scope) {
    $scope.find('.js-image-zoom').each(function () {
        var container = $(this),
            imageContainer = container.find('.js-image-zoom__container'),
            $zoomIn = container.find('.js-image-zoom__btn-in'),
            $zoomOut = container.find('.js-image-zoom__btn-out');

        var currentZoom = 1;
        var maxZoom = 1.6;
        var zoomImage = imageContainer.find('.js-image-zoom__image--zoom');

        function zoomIn(container) {
            currentZoom += .3;
            container.style.transform = 'scale('+currentZoom+')';
        }
        function zoomOut(container) {
            currentZoom -= .3;
            container.style.transform = 'scale('+currentZoom+')';}

        $zoomIn.on('click', function () {
            if (zoomImage) {
                switchImage(zoomImage, true);
                zoomImage.removeClass('hidden');
            }

            if (currentZoom < maxZoom) {
                zoomIn(imageContainer[0]);
            }
        });

        $zoomOut.on('click', function () {
            if (currentZoom > 1) {
                zoomOut(imageContainer[0]);
            }
        });

        function switchImage($img, addLazyLoading) {
            if ($img.is('picture')) {
                $img.find('source, img').each(function () {
                    if (addLazyLoading) {
                        $img.find('img').attr('loading', 'lazy')
                    }
                    if ($(this).data('srcset')) {
                        $(this).attr('srcset', $(this).data('srcset'));
                    }

                    if ($(this).data('src')) {
                        $(this).attr('src', $(this).data('src'));
                    }
                });
            } else {
                if (addLazyLoading) {
                    $img.attr('loading', 'lazy');
                }

                if ($img.data('srcset')) {
                    $img.attr('srcset', $img.data('srcset'));
                }

                if ($img.data('src')) {
                    $img.attr('src', $img.data('src'));
                }
            }
        }
    });
};

app.modules.dynamicModal = function($scope) {
    var element = $scope.find('.js-dynamic-modal-btn');
    var modal = $(element.data('target'));

    element.on('click', function () {
        const that = $(this);
        var loading = modal.find('.js-dynamic-modal__loading');
        var $target = modal.find('.js-dynamic-modal__content');

        loading.attr('hidden', false);

        $.ajax(that.data('content-url'), {
            cache: true,
            dataType : 'json'
        }).done(function (data) {
            if (data.success) {
                $target.html(data.content);
                loading.attr('hidden', 'hidden');

                app.initModules($target);
            }
        }).fail(function (response,errorType,errorText) {
            console.error('error', + response,errorType,errorText)
        });
    });

    if (modal) {
        modal.on('hidden.bs.modal', function () {
            modal.find('.js-dynamic-modal__content').empty();
        });
    }
};

app.modules.calendar = function($scope) {
    var form = $scope.find('.js-calendar__form'),
        calendar = form.closest('.js-calendar');

    form.on('submit', function (evt) {
        evt.preventDefault();
        var loading = calendar.find('.js-calendar__loading');
        var $target = calendar.find('.js-calendar__result');

        if($(this).parsley().validate() === true) {
            loading.attr('hidden', false);
            form.closest('.modal').modal('hide');

            $.ajax(form.data('action'), {
                cache: true,
                dataType : 'json',
                data: $(this).serialize(),
            }).done(function (data) {
                if (data.success) {
                    $target.html(data.content);
                    loading.attr('hidden', 'hidden');

                    calendar.find('.js-calendar__date').removeAttr('disabled');

                    app.initModules($target);
                }
            }).fail(function (response,errorType,errorText) {
                console.error('error', + response,errorType,errorText)
            });
        }
    });
};

app.modules.newsletterProxyIFrame = function() {

    if( insideIFrame() ) {
        setupMessageBus();
    }

    function getHeight() {

        var body = document.body;
        var html = document.documentElement;

        var bodyRect = body.getBoundingClientRect();
        var htmlRect = html.getBoundingClientRect();
        return Math.max( bodyRect.height, htmlRect.height );

        //return Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );
    }

    function insideIFrame() {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    }

    function setupMessageBus() {
        window.addEventListener('message', function (msg) {
            if (msg.data === "getHeight") {
                var height = getHeight();
                parent.postMessage({'height': height},'*');
            }
        });
        document.addEventListener('DOMContentLoaded', function() {
            var height = getHeight();
            parent.postMessage({'height': height},'*');
        }, false);
        window.addEventListener('resize', function () {
            var height = getHeight();
            parent.postMessage({'height': height},'*');
        });
    }
};

app.initModules = function ($scope) {
    if(!$scope) {
        $scope = $('body');
    }

    if (_cfg['_preload']) {
        $.each( _cfg['_preload'], function( _key, _val ){
            if( _cfg['_preload'][_key] && app.modules[_key] && typeof window.app.modules[_key] == 'function' ){
                cls.log('init module: ' + _key);
                window.app.modules[_key]($scope);
            }
        });
    }

    //init all modules if the right _cfg key is set for them
    for (var module in _cfg) {
        if (_cfg[module] && app.modules[module] && typeof  app.modules[module] === 'function') {
            cls.log('init module: ' + module);
            app.modules[module]($scope);
        }
    }

    if (_cfg['_reload']) {
        $.each( _cfg['_reload'], function( _key, _val ){
            if( _cfg['_reload'][_key] && app.modules[_key] && typeof window.app.modules[_key] == 'function' ){
                cls.log('init module ' + _key);
                window.app.modules[_key]($scope);
            }
        });
    }
};

(function( $ ){
    "use strict";

    /* -> _config._preload = Load this functions first */
    if (_cfg['_preload']) {
        $.each( _cfg['_preload'], function( _key, _val ){
            if( typeof _val == 'boolean' && typeof window.app[_key] == 'function' ){
                window.app[_key]();
            }
        });
    }

    /* -> _config = Load all others (not _preload and _reload) */
    $.each( _cfg, function( _key, _val ){
        if( ( typeof _val == 'boolean' && typeof window.app[_key] == 'function' && _key != '_reload' && _key != '_preload' ) ){
            window.app[_key]();
        }
    });

    /* -> _config._reload = Load the ajaxInclued and others after the rest */
    if (_cfg['_reload']) {
        $.each( _cfg['_reload'], function( _key, _val ){
            if( ( typeof _val == 'boolean' && typeof window.app[_key] == 'function' ) ){
                window.app[_key]();
            }
        });
    }

    app.initModules();

})(jQuery);

//btn formaction polyfill
(function () {
    if (!("formAction" in document.createElement("input"))) {
        $('body').on('click', 'button[formaction]:not([type="button"])', function () {
            this.form.action = this.attributes.formAction.value;
            console.log(this.attributes.formAction.value);
        });
    }
}());